import { Location } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Observable, Subject, Subscription } from 'rxjs';
import { CustomAttachFilesComponent } from 'src/app/components/custom-attach-files/custom-attach-files.component';
import { CustomInitialConsecutiveComponent } from 'src/app/components/custom-initial-consecutive/custom-initial-consecutive.component';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { UnitCode } from 'src/app/constants/unit-code-constants';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { ClassMaintenanceOrderEnum, MaintenanceOrderEnums, TypeMaintenanceEnum, TypeMaintenanceOrderEnum, WorkshopTypeEnum } from 'src/app/enum/maintenance-order-enum';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { CostCenterModel } from 'src/app/models/archive/cost-center.model';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { EquipmentInWorkshopTableModel } from 'src/app/models/maintenance/equipment-in-workshop-table.model';
import { MaintenanceOrderPrintModel } from 'src/app/models/maintenance/maintenance-order-print.model';
import { MaintenanceOrderModel } from 'src/app/models/maintenance/maintenance-order.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { ClientService } from 'src/app/services/archive/client.service';
import { CostCenterService } from 'src/app/services/archive/cost-center.service';
import { EquipmentLogbookService } from 'src/app/services/archive/equipment-logbook.service';
import { MaintenanceStrategyService } from 'src/app/services/archive/maintenance-strategy.service';
import { MechanicService } from 'src/app/services/archive/mechanic.service';
import { StoreService } from 'src/app/services/archive/store.service';
import { TransporterService } from 'src/app/services/archive/transporter.service';
import { UnitService } from 'src/app/services/archive/unit.service';
import { VehicleService } from 'src/app/services/archive/vehicle.service';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { MaintenanceOrderActivitiesService } from 'src/app/services/maintenance/maintenance-order-activities.service';
import { MaintenanceOrderService } from 'src/app/services/maintenance/maintenance-order.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { MaintenanceOrderActivitiesComponent } from '../../maintenance-order-activities/maintenance-order-activities/maintenance-order-activities.component';
import { MaintenanceOrderSuppliesComponent } from '../../maintenance-order-supplies/maintenance-order-supplies/maintenance-order-supplies.component';
import { RepairModalComponent } from '../../repair/repair-modal/repair-modal.component';
import { NoteStageModalComponent } from '../note-stage-modal/note-stage-modal.component';
import { InvoiceTableModel } from 'src/app/models/tables/invoicing/invoice-table.model';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { SuspensionModel } from 'src/app/models/rental/suspension.model';
import { DevolutionDetailService } from 'src/app/services/rental/devolution-detail.service';

@Component({
  selector: 'app-register-maintenance-order',
  templateUrl: './register-maintenance-order.component.html',
  styleUrls: ['./register-maintenance-order.component.scss'],
  standalone: false
})
export class RegisterMaintenanceOrderComponent implements OnInit {
  private readonly formControlStateService = inject(FormControlStateService);
  private readonly formatService = inject(FormatService);
  private readonly maintenanceStrategyService = inject(MaintenanceStrategyService);
  private readonly invoiceService = inject(InvoiceService);
  private readonly maintenanceOrderActivitiesService = inject(MaintenanceOrderActivitiesService);
  private readonly equipmentLogbookService = inject(EquipmentLogbookService);
  private readonly unitService = inject(UnitService);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly devolutionDetailService = inject(DevolutionDetailService);

  @ViewChild('addRepair') repairModalComponent?: CustomModalComponent | null = null;
  @ViewChild('attachFileMaintenanceOrder') attachFileMaintenanceOrderComponent?: CustomModalComponent | null = null;
  // @ViewChild('information') informationPopover!: Popover;
  @ViewChild('selectEquipment') equipmentSelectionModalComponent?: CustomModalComponent | null = null;
  @ViewChild('selectNoteStage') noteStageModalComponent?: CustomModalComponent | null = null;
  @ViewChild('initialConsecutive') initialConsecutiveModalComponent?: CustomModalComponent | null = null;
  @ViewChild('maintenanceOrderActivities') maintenanceOrderActivitiesModalComponent?: CustomModalComponent | null = null;
  @ViewChild('maintenanceOrderSupplies') maintenanceOrderSuppliesModalComponent?: CustomModalComponent | null = null;
  @ViewChild('invoiceSelection') invoiceSelectionModalComponent?: CustomModalComponent | null = null;
  articleCodeName: string = '';
  articleId: number = 0;
  articleDisabled: boolean = false;
  ascendantInvoice: boolean = true;
  ascendant: boolean = true;
  branchId: number = 0;
  clientId: number = 0;
  columnSortInvoice: string | null = null;
  columnSort: string | null = null;
  companyId: number = 0;
  componentAttachFiles = CustomAttachFilesComponent;
  componentNoteStageModal = NoteStageModalComponent;
  componentRepairModal = RepairModalComponent;
  componentEquipmentSelection = CustomTableSelectComponent;
  componentInitialConsecutiveModal = CustomInitialConsecutiveComponent;
  componentMaintenanceOrderActivitiesModal = MaintenanceOrderActivitiesComponent;
  componentMaintenanceOrderSuppliesModal = MaintenanceOrderSuppliesComponent;
  componentInvoicesSelection = CustomTableSelectComponent;
  costCenterId: number = 0;
  devolutionConsecutive: string = '';
  devolutionId: number = 0;
  suspensionConsecutive: string = '';
  suspensionId: number = 0;
  disabledChangeStateBtn: boolean = false;
  disabledForm: boolean = false;
  disabledReverseStateBtn: boolean = false;
  enabledPrint: boolean = true;
  invoicesData: PagedResponseModel<InvoiceTableModel> = new PagedResponseModel<InvoiceTableModel>();
  equipmentSelectionData: PagedResponseModel<EquipmentInWorkshopTableModel> = new PagedResponseModel<EquipmentInWorkshopTableModel>();
  equipmentLogbookUnitId: number = 0;
  filtersInvoices: ColumnResponseModel[] = [];
  filtersEquipmentSelection: ColumnResponseModel[] = [];
  formMaintenanceOrder: FormGroup = new FormGroup({});
  formatScheduled: FormatModel = new FormatModel();
  generateOrderRescheduled: boolean = false;
  headersInvoices: ColumnResponseModel[] = [];
  headersEquipmentSelection: ColumnResponseModel[] = [];
  iconStateMaintenanceOrder: string = '';
  iconStateVrRepairCost: string = 'pi pi-lock-open';
  inputsForModals$ = new BehaviorSubject<any>({
    maintenanceOrderId: 0,
    maintenanceOrderClassId: 0,
    permissionUpdatable: false,
    maintenanceOrderStateId: 0,
    swCostRepairState: false,
    swBlock: false
  });

  inputsForSelectEquipmentModal$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    filters: [],
    showCheckbox: true,
    showRecover: true,
    actions: []
  });
  inputsForInvoicesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    filters: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: true
  });

  inputsForAttachFiles$ = new BehaviorSubject<any>({
    listFiles: [],
    labelConsecutive: 0,
    disabled: false
  });
  inputsForMaintenanceOrderActivitiesModal$ = new BehaviorSubject<any>({
    maintenanceOrderModel: MaintenanceOrderModel,
    permissionUpdatable: false
  });
  inputsForMaintenanceOrderSuppliesModal$ = new BehaviorSubject<any>({
    maintenanceOrderModel: MaintenanceOrderModel,
    permissionUpdatable: false
  });
  isOpened: string | undefined = undefined;
  limit: number = 5;
  limitInvoice: number = 10;
  listAttendedOnTime: any[] = [{ label: 'Si', value: true }, { label: 'No', value: false }];
  listBranch: any[] = [];
  listClassMaintenanceOrder: CustomListDropdown[] = [
    { label: 'En Taller', value: ClassMaintenanceOrderEnum.enTaller },
    { label: 'En Sitio', value: ClassMaintenanceOrderEnum.enSitio },
  ];
  listClient: any[] = [];
  listCostCenter: any[] = [];
  listDriver: any[] = [];
  listFiles: any[] = [];
  listMaintenancePlans: CustomListDropdown[] = [];
  listMechanic: any[] = [];
  listServiceRating: CustomListDropdown[] = [{ label: '1', value: 1 }, { label: '2', value: 2 }, { label: '3', value: 3 },
  { label: '4', value: 4 }, { label: '5', value: 5 }];
  listTypeMaintenance: CustomListDropdown[] = [
    { label: 'Preventivo', value: TypeMaintenanceEnum.preventivo },
    { label: 'Correctivo', value: TypeMaintenanceEnum.correctivo },
    { label: 'Predictivo', value: TypeMaintenanceEnum.predictivo }];
  listTypeMaintenanceOrder: any[] = [
    { label: 'Equipo Propio de Obra', value: TypeMaintenanceOrderEnum.equipoPropioDeObra, class: ClassMaintenanceOrderEnum.enTaller },
    { label: 'Equipo Propio de Almacén', value: TypeMaintenanceOrderEnum.equipoPropioDeAlmacen, class: ClassMaintenanceOrderEnum.enTaller },
    { label: 'Equipo de Tercero en Taller', value: TypeMaintenanceOrderEnum.equipoDeTerceroEnTaller, class: ClassMaintenanceOrderEnum.enTaller },
    { label: 'Equipo Propio en Obra', value: TypeMaintenanceOrderEnum.equipoPropioEnObra, class: ClassMaintenanceOrderEnum.enSitio },
    { label: 'Equipo Cliente en Obra', value: TypeMaintenanceOrderEnum.equipoClienteEnObra, class: ClassMaintenanceOrderEnum.enSitio },
    { label: 'Equipo de Tercero en Campo', value: TypeMaintenanceOrderEnum.equipoDeTerceroEnCampo, class: ClassMaintenanceOrderEnum.enSitio },
  ];
  listTypeMaintenanceOrderForClass: CustomListDropdown[] = [];
  listVehicle: any[] = [];
  listWorkshopType: CustomListDropdown[] = [{ label: 'Limpieza', value: WorkshopTypeEnum.taller2 }, { label: 'Reparación', value: WorkshopTypeEnum.taller3 }];
  maintenanceOrderId: number = 0;
  maintenanceOrderClass: number = 0;
  maintenanceOrderContract: MaintenanceOrderModel = new MaintenanceOrderModel();
  maintenanceOrderPrintModel: MaintenanceOrderPrintModel = new MaintenanceOrderPrintModel();
  maintenanceOrderStateId: number = 0;
  maintenanceOrderStateString: string = "";
  maintenanceOrderType: number = 0;
  swMaintenanceOrderScheduled: boolean = false;
  swGenerateSuspensionsOM: boolean = false;
  mechanicId: number = 0;
  nameWindow: string = 'Orden de Mantenimiento Captura';
  noteStageCurrent: string = '';
  output$ = new Subject<any>();
  outputForInvoices$ = new Subject<any>();
  outputForAttachFiles$ = new Subject<any>();
  outputForInitialConsecutive$ = new Subject<any>();
  page: number = 1;
  pageInvoice: number = 1;
  permissionPrint: boolean = true;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  permissionUpdatable: boolean = false;
  printOmOnBlank: boolean = false;
  projectName = ProjectName.projectName;
  reloadPrintSite: boolean = false;
  reloadPrintScheduled: boolean = false;
  reloadPrintWorkshop: boolean = false;
  storeCodeName: string = '';
  storeId: number | null = 0;
  subscription: Subscription;
  swCostRepairState: boolean = false;
  transporterId: number = 0;
  titleStateMaintenanceOrder: string = 'Cerrar';
  titleStateVrRepairCost: string = 'Cerrar';
  totalMaintenanceOrderActivities: number = 0;
  totalActivitiesRescheduled: number = 0;
  typeEquipmentOwnShop = TypeMaintenanceOrderEnum.equipoPropioDeAlmacen;
  userAuthenticated: UserModel = new UserModel();
  url: string = "maintenance-order";
  unitHoursId: number = 0;
  vehicleId: number = 0;
  workshopClass = ClassMaintenanceOrderEnum.enTaller;
  siteClass = ClassMaintenanceOrderEnum.enSitio;
  scheduledClass = ClassMaintenanceOrderEnum.programada;
  constructor(private activatedRoute: ActivatedRoute,
    private articleService: ArticleService,
    private branchService: BranchService,
    private dateConverterService: DateConverterService,
    private clientService: ClientService,
    private costCenterService: CostCenterService,
    private formBuilder: FormBuilder,
    private location: Location,
    private maintenanceOrderService: MaintenanceOrderService,
    private mechanicService: MechanicService,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private storeService: StoreService,
    private title: Title,
    private headerService: HeaderService,
    private toastHandlerService: ToastHandlerService,
    private transporterService: TransporterService,
    private userAuthenticatedService: UserAuthenticatedService,
    private vehicleService: VehicleService,
    private windowService: WindowService,) {
    this.validateForm(this.maintenanceOrderContract);
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} -  ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.maintenanceOrderId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.getPermission();
    await this.handleInitialState();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeEquipment(payload);
          break;
        case 'onFilterChange':
          this.onFilterChangeEquipment(payload);
          break;
        case 'onReload':
          this.getTotalMaintenanceOrderActivities();
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.outputForInvoices$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeInvoice(payload);
          break;
        case 'onFilterChange':
          this.onFilterChangeInvoice(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.outputForAttachFiles$.subscribe(async ({ type, payload }) => {
      switch (type) {
        case 'uploadFile':
          this.uploadFile(payload);
          break;
        case 'downloadFile':
          this.downloadFile(payload);
          break;
        case 'deleteFile':
          this.deleteFile(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.outputForInitialConsecutive$.subscribe(async ({ type, payload }) => {
      if (type === 'initialConsecutive') {
        this.formMaintenanceOrder.patchValue({
          consecutive: payload.consecutive
        });
        await this.send();
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
    this.subscription?.unsubscribe();
  }

  async annulMaintenanceOrder() {
    if (this.maintenanceOrderContract.maintenanceOrderId != 0 && this.maintenanceOrderId != null) {
      const canUpdate = await this.validatePermissionUpdatable();
      if (!canUpdate) return;
      if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.anular)) {
        if (this.maintenanceOrderContract.maintenanceOrderStateId != MaintenanceOrderEnums.abierta) {
          this.toastHandlerService.showToast(
            'warning',
            'Solo se puede anular una orden de mantenimiento en estado Abierta.'
          );
          return;
        }
        try {
          this.maintenanceOrderContract = await firstValueFrom(this.maintenanceOrderService.annulMaintenanceOrderAsync(this.maintenanceOrderId));
          this.validateForm(this.maintenanceOrderContract);
        } catch (error) {
          console.error('Error al bloquear/desbloquear la orden de mantenimiento.', error);
        }
      } else {
        this.toastHandlerService.showToast(
          'error',
          'El usuario no tiene permisos para anular ordenes de mantenimiento. Comuníquese con el administrador del sistema.'
        );
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una orden de mantenimiento.'
      );
    }
  }

  async blockMaintenanceOrder(event: boolean) {
    if (this.maintenanceOrderId != 0 && this.maintenanceOrderId != null) {
      const canUpdate = await this.validatePermissionUpdatable();
      if (!canUpdate) {
        setTimeout(() => { this.formMaintenanceOrder.controls['swBlock'].patchValue(!event) }, 100);
        return;
      }
      if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.bloquear)) {
        try {
          this.maintenanceOrderContract = await firstValueFrom(this.maintenanceOrderService.blockMaintenanceOrderAsync(this.maintenanceOrderId));
          this.validateForm(this.maintenanceOrderContract);
        } catch (error) {
          setTimeout(() => { this.formMaintenanceOrder.controls['swBlock'].patchValue(!event) }, 100);
          console.error('Error al bloquear/desbloquear la orden de mantenimiento.', error);
        }
      } else {
        this.toastHandlerService.showToast(
          'error',
          'El usuario no tiene permisos para bloquear/desbloquear Ordenes de Mantenimiento. Comuníquese con el administrador del sistema.'
        );
        setTimeout(() => { this.formMaintenanceOrder.controls['swBlock'].patchValue(!event) }, 100);
        return;
      }
    } else {
      setTimeout(() => { this.formMaintenanceOrder.controls['swBlock'].patchValue(!event) }, 100);
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una orden de mantenimiento.'
      );
    }
  }

  changeBranch(branchId: number | null) {
    if (branchId === null || branchId === 0) {
      this.branchId = 0;
    } else {
      this.branchId = branchId;
    }
    this.formMaintenanceOrder.controls['maintenanceOrderClassId'].patchValue(0);
    this.formMaintenanceOrder.controls['maintenanceOrderTypeId'].patchValue(0);
    this.maintenanceOrderClass = 0;
    this.maintenanceOrderType = 0;
    this.articleCodeName = '';
    this.articleId = 0;
    this.storeCodeName = '';
    this.storeId = 0;
    this.totalMaintenanceOrderActivities = 0;
    this.noteStageCurrent = '';
    this.maintenanceOrderId = 0;
    this.maintenanceOrderContract = new MaintenanceOrderModel();
    this.maintenanceOrderContract.branchId = this.branchId;
    this.maintenanceOrderContract.maintenanceOrderClassId = this.maintenanceOrderClass;
    this.maintenanceOrderContract.maintenanceOrderStateId = MaintenanceOrderEnums.abierta;
    this.validateForm(this.maintenanceOrderContract);
    this.getAllLists('costCenters', 'drivers', 'mechanics', 'vehicles');
  }

  async changeClient(clientId: number) {
    const { maintenanceOrderTypeId, maintenanceOrderClassId } = this.formMaintenanceOrder.value;
    const isOwnEquipmentOnSite = maintenanceOrderTypeId === TypeMaintenanceOrderEnum.equipoPropioEnObra &&
      maintenanceOrderClassId === ClassMaintenanceOrderEnum.enSitio;

    if (isOwnEquipmentOnSite) {
      if (await this.hasSuspensionInInvoicingCutoffAsync()) {
        this.formMaintenanceOrder.controls['clientId'].patchValue(this.maintenanceOrderContract.clientId);
        return;
      }

      if (this.articleId != 0) {
        this.toastHandlerService.showToast(
          'error',
          'No es posible modificar el cliente mientras tenga un artículo definido.'
        );
        this.formMaintenanceOrder.controls['clientId'].patchValue(this.maintenanceOrderContract.clientId);
        return;
      }
    }

    if (maintenanceOrderTypeId == TypeMaintenanceOrderEnum.mantenimientoProgramado && this.articleId != 0) {
      this.toastHandlerService.showToast(
        'error',
        'No es posible modificar el cliente mientras tenga un artículo definido.'
      );
      this.getAllLists('clients');
      this.formMaintenanceOrder.controls['clientId'].patchValue(this.maintenanceOrderContract.clientId);
      return;
    }

    this.formMaintenanceOrder.controls["costCenterId"].patchValue(0);
    if (clientId && clientId !== 0) {
      this.clientId = clientId;
    } else {
      this.clientId = 0;
      this.formMaintenanceOrder.controls["clientId"].patchValue(0);
    }
    this.getAllLists('costCenters');
  }

  async changeConsecutive(consecutive: number) {
    if (this.maintenanceOrderContract.consecutive == consecutive) return;
    const branchId = this.formMaintenanceOrder.get("branchId")?.value;
    const maintenanceOrderClassId = this.formMaintenanceOrder.get("maintenanceOrderClassId")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    } else if (maintenanceOrderClassId == null || maintenanceOrderClassId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una Clase O.M.'
      );
      return;
    } else if (consecutive == 0) {
      consecutive = 0;
    }

    if (consecutive == null || consecutive == 0) {
      this.maintenanceOrderId = 0;
      this.devolutionConsecutive = '';
      this.devolutionId = 0;
      this.suspensionConsecutive = '';
      this.suspensionId = 0;
      const modelmaintenanceOrder = new MaintenanceOrderModel();
      modelmaintenanceOrder.branchId = branchId;
      modelmaintenanceOrder.maintenanceOrderClassId = maintenanceOrderClassId;
      this.maintenanceOrderContract.maintenanceOrderStateId = MaintenanceOrderEnums.abierta;
      this.maintenanceOrderContract = modelmaintenanceOrder;
    } else {
      try {
        this.maintenanceOrderContract = await firstValueFrom(this.maintenanceOrderService
          .getMaintenanceOrderByKeysAsync(consecutive, branchId, maintenanceOrderClassId));
        this.maintenanceOrderId = this.maintenanceOrderContract.maintenanceOrderId;
        this.validateForm(this.maintenanceOrderContract);
        this.location.replaceState(`/maintenance-order/register/${this.maintenanceOrderId}`);
      } catch (error) {
        this.articleCodeName = '';
        this.articleId = 0;
        this.storeCodeName = '';
        this.storeId = 0;
        this.totalMaintenanceOrderActivities = 0;
        this.noteStageCurrent = '';
        this.articleDisabled = false;
        this.maintenanceOrderId = 0;
        this.maintenanceOrderContract = new MaintenanceOrderModel();
        this.maintenanceOrderContract.branchId = this.branchId;
        this.maintenanceOrderContract.maintenanceOrderClassId = this.maintenanceOrderClass;
        this.validateForm(this.maintenanceOrderContract);
        this.location.replaceState(`/maintenance-order/register`);
        console.error('Error al buscar la orden de mantenimiento por Consecutivo.', error);
      }
    }
  }

  async changeCostCenter(costCenterId: number) {
    const { maintenanceOrderTypeId, maintenanceOrderClassId } = this.formMaintenanceOrder.value;
    const isOwnEquipmentOnSite = maintenanceOrderTypeId === TypeMaintenanceOrderEnum.equipoPropioEnObra &&
      maintenanceOrderClassId === ClassMaintenanceOrderEnum.enSitio;

    if (isOwnEquipmentOnSite) {
      if (await this.hasSuspensionInInvoicingCutoffAsync()) {
        this.formMaintenanceOrder.controls['costCenterId'].patchValue(this.maintenanceOrderContract.costCenterId);
        return;
      }

      if (this.articleId != 0) {
        this.toastHandlerService.showToast(
          'error',
          'No es posible modificar el centro de costos mientras tenga un artículo definido.'
        );
        this.formMaintenanceOrder.controls['costCenterId'].patchValue(this.maintenanceOrderContract.costCenterId);
        return;
      }
    }

    if (maintenanceOrderTypeId == TypeMaintenanceOrderEnum.mantenimientoProgramado && this.articleId != 0) {
      this.toastHandlerService.showToast(
        'error',
        'No es posible modificar el centro de costos mientras tenga un artículo definido.'
      );
      this.getAllLists('costCenters');
      this.formMaintenanceOrder.controls['costCenterId'].patchValue(this.maintenanceOrderContract.costCenterId);
      return;
    }

    this.costCenterId = costCenterId;
    const costCenter = await this.getCostCenterById(costCenterId);
    const clientId = costCenter?.clientId || 0;

    this.formMaintenanceOrder.controls['clientId'].patchValue(clientId);
    if (this.clientId != clientId) {
      this.clientId = clientId;
      this.getAllLists('costCenters');
    }
  }

  async changeKmHoromValue(value: number) {
    if (this.equipmentLogbookUnitId == this.unitHoursId && this.maintenanceOrderContract.maintenanceOrderClassId == ClassMaintenanceOrderEnum.programada) {
      if (value == null || value == undefined) return;
      await this.validateKmHoromValue(value);
    }
  }

  async changeCostRepairState() {
    if (this.maintenanceOrderContract.maintenanceOrderId == 0 || this.maintenanceOrderContract.maintenanceOrderId == null) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una orden de mantenimiento.'
      );
      return;
    }
    const canUpdate = await this.validatePermissionUpdatable();
    if (!canUpdate) return;

    if (!(await this.confirmDialogService.confirm('¿Realmente desea cambiar el estado de Reparaciones - Costos?'))) {
      return;
    }
    if (this.maintenanceOrderContract.swCostRepairState) {
      this.maintenanceOrderContract.swCostRepairState = false;
    } else {
      this.maintenanceOrderContract.swCostRepairState = true;
    }
    this.maintenanceOrderContract = await firstValueFrom(this.maintenanceOrderService.updateMaintenanceOrder(this.maintenanceOrderContract));
    this.validateForm(this.maintenanceOrderContract);
    this.toastHandlerService.showToast(
      'success',
      'El estado de las reparaciones - costos se modificó exitosamente.'
    );
  }

  async changeDateInitial() {
    if (await this.hasSuspensionInInvoicingCutoffAsync()) {
      this.formMaintenanceOrder.get('dateInitialMaintenanceOrder')?.patchValue(
        this.maintenanceOrderContract.dateInitialMaintenanceOrder
          ? this.dateConverterService.convertUtcToLocalDateFull(this.maintenanceOrderContract.dateInitialMaintenanceOrder)
          : null
      );
      return;
    }
  }

  async changeDateFinal(event: any) {
    if (await this.hasSuspensionInInvoicingCutoffAsync()) {
      this.formMaintenanceOrder.get('dateFinalMaintenanceOrder')?.patchValue(
        this.maintenanceOrderContract.dateFinalMaintenanceOrder
          ? this.dateConverterService.convertUtcToLocalDateFull(this.maintenanceOrderContract.dateFinalMaintenanceOrder)
          : null
      );
      return;
    }

    const dateInitial = this.dateConverterService.convertUtcToLocalDate(this.formMaintenanceOrder.get('dateInitialMaintenanceOrder')?.value);
    const dateFinal = this.dateConverterService.convertUtcToLocalDate(event);
    if (dateFinal.getTime() < dateInitial.getTime()) {
      this.toastHandlerService.showToast(
        'warning',
        'La fecha final del diagnóstico debe ser mayor a la fecha inicial.'
      );
      this.formMaintenanceOrder.get('dateFinalMaintenanceOrder')?.patchValue(dateInitial);
      return;
    }
    if (this.maintenanceOrderId !== 0 && this.maintenanceOrderId !== null) {
      const dateFinalOld = this.maintenanceOrderContract.dateFinalMaintenanceOrder
        ? new Date(this.maintenanceOrderContract.dateFinalMaintenanceOrder) : new Date();
      this.maintenanceOrderContract.dateFinalMaintenanceOrder = event;
      try {
        await firstValueFrom(this.maintenanceOrderService.updateMaintenanceOrder(this.maintenanceOrderContract));
      } catch (error) {
        this.maintenanceOrderContract.dateFinalMaintenanceOrder = dateFinalOld;
        this.formMaintenanceOrder.get('dateFinalMaintenanceOrder')?.patchValue(dateFinalOld);
        console.error('Error al modificar la fecha final de la orden de mantenimiento.', error);
      }
    }
  }

  async changeMaintenanceOrderClass(event: any) {
    if (event != null && event != undefined) {
      this.listTypeMaintenanceOrderForClass = this.listTypeMaintenanceOrder.filter(item => item.class == event);
      this.maintenanceOrderClass = event;
    } else {
      this.listTypeMaintenanceOrderForClass = [];
      this.maintenanceOrderClass = 0;
    }
    this.formMaintenanceOrder.controls['maintenanceOrderTypeId'].patchValue(0);
    if (this.maintenanceOrderClass == ClassMaintenanceOrderEnum.programada) {
      this.maintenanceOrderType = TypeMaintenanceOrderEnum.mantenimientoProgramado;
    } else {
      this.maintenanceOrderType = 0;
    }
    this.storeId = 0;
    this.clientId = 0;
    this.articleId = 0;
    this.costCenterId = 0;
    this.maintenanceOrderId = 0;
    this.totalMaintenanceOrderActivities = 0;
    this.storeCodeName = '';
    this.articleCodeName = '';
    this.noteStageCurrent = '';
    this.articleDisabled = false;
    await this.getAllLists('costCenters');
    this.maintenanceOrderContract = new MaintenanceOrderModel();
    this.maintenanceOrderContract.branchId = this.branchId;
    this.maintenanceOrderContract.maintenanceOrderClassId = this.maintenanceOrderClass;
    this.maintenanceOrderContract.maintenanceOrderStateId = MaintenanceOrderEnums.abierta;
    this.defaultMaintenanceOrderClass(this.maintenanceOrderClass);
    this.location.replaceState(`/maintenance-order/register`);
    this.validateForm(this.maintenanceOrderContract);
  }

  changeMaintenanceOrderType(event: any, onInit: boolean) {
    if (!onInit) {
      if (this.articleId != 0 && this.articleId != null) {
        setTimeout(() => this.formMaintenanceOrder.controls['maintenanceOrderTypeId'].patchValue(this.maintenanceOrderType), 100);
        this.toastHandlerService.showToast(
          'warning',
          'No se permite cambiar este campo despues de definido un equipo.'
        );
        return;
      }
    }
    if (event != null && event != undefined) {
      if (!onInit) {
        this.articleCodeName = '';
        this.articleId = 0;
        this.storeCodeName = '';
        this.storeId = 0;
        this.maintenanceOrderType = event;
        this.maintenanceOrderId = 0;
        this.devolutionConsecutive = '';
        this.devolutionId = 0;
        this.suspensionConsecutive = '';
        this.suspensionId = 0;
        this.totalMaintenanceOrderActivities = 0;
      }
      switch (event) {
        case TypeMaintenanceOrderEnum.equipoPropioDeObra: {
          if (!onInit) {
            this.formMaintenanceOrder.patchValue({ clientId: null, costCenterId: null });
          }
          setTimeout(() => this.formControlStateService.setControlState(this.formMaintenanceOrder, ['workshopType', 'clientId', 'costCenterId'], false), 100);
          break;
        }
        case TypeMaintenanceOrderEnum.equipoPropioDeAlmacen: {
          if (!onInit) {
            const client = this.listClient.find(x => x.label.startsWith('00000000') && x.label.toLowerCase().includes('ninguno'));
            const clientId = client?.value;
            const costCenter = this.listCostCenter.find(x => x.label.startsWith('1 -'));
            this.costCenterId = costCenter?.value ? costCenter.value : 0;
            this.formMaintenanceOrder.controls['costCenterId'].patchValue(this.costCenterId);// Almacén
            this.formMaintenanceOrder.controls['clientId'].patchValue(clientId);// Cliente <Ninguno>
          }
          setTimeout(() => this.formControlStateService.setControlState(this.formMaintenanceOrder, ['clientId', 'costCenterId'], false), 100);
          break;
        }
        case TypeMaintenanceOrderEnum.equipoDeTerceroEnTaller: {
          if (!onInit) {
            this.formMaintenanceOrder.patchValue({ clientId: 0, costCenterId: 0 });
          }
          setTimeout(() => this.formControlStateService.setControlState(this.formMaintenanceOrder, ['workshopType', 'clientId', 'costCenterId'], true), 100);
          break;
        }
        case TypeMaintenanceOrderEnum.equipoPropioEnObra: {
          if (!onInit) {
            this.formMaintenanceOrder.patchValue({ clientId: 0, costCenterId: 0 });
          }
          setTimeout(() => this.formControlStateService.setControlState(this.formMaintenanceOrder, ['workshopType', 'clientId', 'costCenterId'], true), 100);
          break;
        }
        case TypeMaintenanceOrderEnum.equipoClienteEnObra: {
          if (!onInit) {
            this.formMaintenanceOrder.patchValue({ clientId: 0, costCenterId: 0 });
          }
          setTimeout(() => this.formControlStateService.setControlState(this.formMaintenanceOrder, ['workshopType', 'clientId', 'costCenterId'], true), 100);
          break;
        }
        case TypeMaintenanceOrderEnum.mantenimientoProgramado: {
          this.getAllLists('costCenters');
          setTimeout(() => this.formControlStateService.setControlState(this.formMaintenanceOrder, ['clientId', 'costCenterId'], true), 100);
          break;
        }
      }
      const enable = event != TypeMaintenanceOrderEnum.mantenimientoProgramado;
      setTimeout(() => this.formControlStateService.setControlState(this.formMaintenanceOrder, [
        'maintenanceOrderTypeId', 'workshopType', 'maintenanceTypeId', 'dateInitialMaintenanceOrder', 'initialDiagnosis'], enable), 100);
      setTimeout(() => this.formMaintenanceOrder.controls['consecutive'].disable(), 100);
    } else {
      this.maintenanceOrderType = 0;
    }
  }

  async changeState() {
    if (this.maintenanceOrderId != 0 && this.maintenanceOrderId != null) {
      const canUpdate = await this.validatePermissionUpdatable();
      if (!canUpdate) return;
      const dateFinalMaintenanceOrder = this.formMaintenanceOrder.get('dateFinalMaintenanceOrder')?.value;
      if (!dateFinalMaintenanceOrder) {
        this.toastHandlerService.showToast(
          'warning',
          'Debe ingresar la Fecha Final de la orden de mantenimiento.'
        );
        return;
      }
      const finalDiagnosis = this.formMaintenanceOrder.get('finalDiagnosis')?.value;
      if (!finalDiagnosis) {
        this.toastHandlerService.showToast(
          'warning',
          'Debe ingresar el Diagnóstico Final de la orden de mantenimiento.'
        );
        return;
      }

      const repairHour = this.formMaintenanceOrder.get('repairHour')?.value;
      if (repairHour == null || repairHour == 0) {
        this.toastHandlerService.showToast(
          'warning',
          'Debe ingresar las Horas de Reparación de la orden de mantenimiento.'
        );
        return;
      }

      //Validar que la fecha final del diagnóstico sea mayor a la fecha inicial del diagnóstico
      const dateInitial = this.dateConverterService.convertUtcToLocalDate(this.formMaintenanceOrder.get('dateInitialMaintenanceOrder')?.value);
      const dateFinal = this.dateConverterService.convertUtcToLocalDate(dateFinalMaintenanceOrder);
      if (dateFinal.getTime() < dateInitial.getTime()) {
        this.toastHandlerService.showToast(
          'warning',
          'La fecha final del diagnóstico debe ser mayor a la fecha inicial.'
        );
        return;
      }

      //validaciones orden programada
      if (!await this.validationsOrderScheduled()) {
        return;
      }

      const chargeConstructionSite = this.formMaintenanceOrder.get('swChargeConstructionSite')?.value;
      const valueToInvoiced = this.formMaintenanceOrder.get('valueToInvoiced')?.value;
      const invoiceNumber = this.formMaintenanceOrder.get('invoiceNumber')?.value;
      const maintenanceOrderStateIdOld = this.maintenanceOrderStateId;
      switch (this.maintenanceOrderStateId) {
        case MaintenanceOrderEnums.abierta: {
          if (this.maintenanceOrderContract.maintenanceOrderClassId == ClassMaintenanceOrderEnum.enTaller) {
            if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.CierreInicialOM)) {
              this.maintenanceOrderStateId = MaintenanceOrderEnums.cierreInicial;
            } else {
              this.toastHandlerService.showToast(
                'error',
                'El usuario no tiene permisos para realizar el Cierre Inicial de la orden de mantenimiento. Comuníquese con el administrador del sistema.'
              );
              return;
            }
          } else {
            if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.CierreFinalOM)) {
              if (chargeConstructionSite) {
                const valueToInvoiced = this.formMaintenanceOrder.get('valueToInvoiced')?.value;
                if (!valueToInvoiced || valueToInvoiced === 0) {
                  this.toastHandlerService.showToast(
                    'warning',
                    'Debe ingresar el Valor a Facturar de la orden de mantenimiento.'
                  );
                  return;
                }
                if (!invoiceNumber || invoiceNumber.trim() === '') {
                  this.toastHandlerService.showToast(
                    'warning',
                    'Debe ingresar el Número de factura de la orden de mantenimiento.'
                  );
                  return;
                }
              }
              this.maintenanceOrderStateId = MaintenanceOrderEnums.cierreFinal;
            } else {
              this.toastHandlerService.showToast(
                'warning',
                'El usuario no tiene permisos para realizar el cierre final de la orden de mantenimiento. Comuníquese con el administrador del sistema.'
              );
              return;
            }
          }
          break;
        }
        case MaintenanceOrderEnums.cierreInicial: {
          if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.CierreFinalOM)) {
            const chargeConstructionSite = this.formMaintenanceOrder.get('swChargeConstructionSite')?.value;
            if (chargeConstructionSite) {
              if (!valueToInvoiced || valueToInvoiced === 0) {
                this.toastHandlerService.showToast(
                  'warning',
                  'Debe ingresar el valor a facturar de la orden de mantenimiento.'
                );
                return;
              }
              const invoiceNumber = this.formMaintenanceOrder.get('invoiceNumber')?.value;
              if (!invoiceNumber || invoiceNumber.trim() === '') {
                this.toastHandlerService.showToast(
                  'warning',
                  'Debe ingresar el número de factura de la orden de mantenimiento.'
                );
                return;
              }
            }
            this.maintenanceOrderStateId = MaintenanceOrderEnums.cierreFinal;
          } else {
            this.toastHandlerService.showToast(
              'error',
              'El usuario no tiene permisos para realizar el cierre final de la orden de mantenimiento. Comuníquese con el administrador del sistema.'
            );
            return;
          }
          break;
        }
        case MaintenanceOrderEnums.cierreFinal: {
          if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.abrir)) {
            this.maintenanceOrderStateId = MaintenanceOrderEnums.abierta;
          } else {
            this.toastHandlerService.showToast(
              'error',
              'El usuario no tiene permisos para reversar estados de la orden de mantenimiento. Comuníquese con el administrador del sistema.'
            );
            return;
          }
          break;
        }
      }
      try {
        this.maintenanceOrderContract.maintenanceOrderStateId = this.maintenanceOrderStateId;
        this.maintenanceOrderContract.dateFinalMaintenanceOrder = dateFinalMaintenanceOrder;
        this.maintenanceOrderContract.finalDiagnosis = finalDiagnosis;
        this.maintenanceOrderContract.valueToInvoiced = valueToInvoiced;
        this.maintenanceOrderContract.invoiceNumber = invoiceNumber;
        this.maintenanceOrderContract.repairHour = repairHour;
        if (this.equipmentLogbookUnitId == this.unitHoursId && this.maintenanceOrderContract.maintenanceOrderClassId == ClassMaintenanceOrderEnum.programada) {
          this.maintenanceOrderContract.kmHoromValue = this.formMaintenanceOrder.get('kmHoromValue')?.value;
        }

        //valido si debe generar la orden reprogramada
        if (this.generateOrderRescheduled) {
          try {
            if (!(await this.createRescheduledMaintenanceOrder())) return;
          } catch (error) {
            console.error('Error al generar la orden de mantenimiento reprogramada.', error);
            return;
          }
        }

        this.maintenanceOrderContract = await firstValueFrom(this.maintenanceOrderService.updateMaintenanceOrder(this.maintenanceOrderContract));
        this.validateForm(this.maintenanceOrderContract);
        this.toastHandlerService.showToast(
          'success',
          'La orden de mantenimiento fue modificada exitosamente.'
        );

        //valido si debe generar la suspensión del equipo al hacer el cierre final
        if (maintenanceOrderStateIdOld != MaintenanceOrderEnums.cierreFinal && this.maintenanceOrderStateId == MaintenanceOrderEnums.cierreFinal) {
          await this.manageSuspensionAsync();
        }
      } catch (error) {
        this.maintenanceOrderStateId = maintenanceOrderStateIdOld;
        console.error('Error al actualizar el estado de la orden de mantenimiento.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una orden de mantenimiento.'
      );
    }
  }

  async changeSwChargeConstructionSite(event: boolean, onInit: boolean) {
    if (event) {
      setTimeout(() => {
        this.formMaintenanceOrder.controls['valueToInvoiced'].enable();
        this.formMaintenanceOrder.controls['invoiceNumber'].enable();
      }, 100);
    } else {
      setTimeout(() => {
        if (!onInit) {
          this.formMaintenanceOrder.controls['valueToInvoiced'].patchValue(0);
          this.formMaintenanceOrder.controls['invoiceNumber'].patchValue('');
        }
        this.formMaintenanceOrder.controls['valueToInvoiced'].disable();
        this.formMaintenanceOrder.controls['invoiceNumber'].disable();
      }, 100);
    }
  }

  async createNewMaintenanceOrder(reloadCostCenters: boolean = true) {
    if (this.permissionUpdatable) {
      this.maintenanceOrderId = 0;
      this.storeId = 0;
      this.clientId = 0;
      this.articleId = 0;
      this.costCenterId = 0;
      this.totalMaintenanceOrderActivities = 0;
      this.storeCodeName = '';
      this.articleCodeName = '';
      this.noteStageCurrent = '';
      this.articleDisabled = false;
      if (reloadCostCenters) await this.getAllLists('costCenters');
      this.maintenanceOrderContract = new MaintenanceOrderModel();
      this.maintenanceOrderContract.branchId = this.branchId;
      this.maintenanceOrderContract.vehicleId = this.vehicleId;
      this.maintenanceOrderContract.mechanicId = this.mechanicId;
      this.maintenanceOrderContract.transporterId = this.transporterId;
      this.maintenanceOrderContract.maintenanceOrderStateId = MaintenanceOrderEnums.abierta;
      this.maintenanceOrderContract.maintenanceOrderClassId = this.maintenanceOrderClass;
      this.defaultMaintenanceOrderClass(this.maintenanceOrderClass);
      this.validateForm(this.maintenanceOrderContract);
      setTimeout(() => { this.formMaintenanceOrder.controls['consecutive'].disable() }, 100);
      this.location.replaceState(`/maintenance-order/register`);
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para crear ordenes de mantenimiento. Comuníquese con el administrador del sistema.'
      );
    }
  }

  async createRescheduledMaintenanceOrder(): Promise<boolean> {
    try {
      const maintenanceOrderRescheduled = await firstValueFrom(this.maintenanceOrderService.createRescheduledMaintenanceOrder(this.maintenanceOrderContract.maintenanceOrderId));
      if (maintenanceOrderRescheduled.maintenanceOrderId != null && maintenanceOrderRescheduled.maintenanceOrderId != 0) {
        this.toastHandlerService.showToast(
          'info',
          `Se ha reprogramado exitosamente, se creo la orden mtto. ${maintenanceOrderRescheduled.consecutive}.`
        );
      } else {
        this.toastHandlerService.showToast(
          'error',
          'No se ha podido reprogramar la orden de mantenimiento.'
        );
        return false;
      }
      return true;
    } catch (error) {
      console.error('Error al reprogramar la orden de mantenimiento', error);
      return false;
    }
  }

  async deleteMaintenanceOrder() {
    if (this.maintenanceOrderId != 0 && this.maintenanceOrderId != null) {
      const canUpdate = await this.validatePermissionUpdatable();
      if (!canUpdate) return;
      if (this.maintenanceOrderContract.maintenanceOrderStateId != MaintenanceOrderEnums.abierta) {
        this.toastHandlerService.showToast(
          'warning',
          'Solo se puede eliminar una orden de mantenimiento en estado Abierta.'
        );
        return;
      }

      if (this.maintenanceOrderContract.maintenanceOrderClassId == ClassMaintenanceOrderEnum.programada) {
        if (this.maintenanceOrderContract.consecutiveMaintenanceScheduling != null) {
          this.toastHandlerService.showToast(
            'warning',
            'No es posible eliminar. La orden de mantenimiento se ha generado desde una programación.'
          );
          return;
        } else if (this.maintenanceOrderContract.maintenanceOrderOriginId != null) {
          this.toastHandlerService.showToast(
            'warning',
            'No es posible eliminar. La orden de mantenimiento se ha generado desde una reprogramación.'
          );
          return;
        }
      }

      if (!(await this.confirmDialogService.confirm(
        `¿Realmente desea eliminar la orden de mantenimiento ${this.maintenanceOrderContract.consecutive}?`
      ))) {
        return;
      }
      try {
        await firstValueFrom(this.maintenanceOrderService.deleteMaintenanceOrder(this.maintenanceOrderContract.maintenanceOrderId));
        this.toastHandlerService.showToast(
          'success',
          'La orden de mantenimiento fue eliminada exitosamente.'
        );
        this.createNewMaintenanceOrder();
      } catch (error) {
        console.error('Error al eliminar la orden de mantenimiento.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una orden de mantenimiento.'
      );
    }
  }

  defaultMaintenanceOrderClass(maintenanceOrderClass: number) {
    if (maintenanceOrderClass == ClassMaintenanceOrderEnum.programada) {
      this.maintenanceOrderContract.maintenanceOrderTypeId = TypeMaintenanceOrderEnum.mantenimientoProgramado;
      this.maintenanceOrderContract.workshopType = WorkshopTypeEnum.taller3;
      this.maintenanceOrderContract.maintenanceTypeId = TypeMaintenanceEnum.preventivo;
      this.changeMaintenanceOrderType(TypeMaintenanceOrderEnum.mantenimientoProgramado, true);
      this.getUnitHours();
    } else if (maintenanceOrderClass == ClassMaintenanceOrderEnum.enSitio) {
      this.maintenanceOrderContract.dateCompromise = this.maintenanceOrderContract.dateMaintenanceOrder;
    }
  }

  async deleteFile(file: any) {
    if (this.maintenanceOrderContract.maintenanceOrderId != 0) {
      if (!(await this.confirmDialogService.confirm('¿Realmente desea eliminar el adjunto seleccionado?'))) {
        return;
      }
      try {
        await firstValueFrom(this.maintenanceOrderService.deleteFilesToMaintenanceOrder(this.maintenanceOrderContract.maintenanceOrderId, file));
        this.toastHandlerService.showToast(
          'success',
          'El adjunto fue eliminado exitosamente'
        );
        this.getFilesToMaintenanceOrder();
      } catch (error) {
        console.error('Error catch:', error);
      }
    }
  }

  downloadFile(fileName: any) {
    if (this.maintenanceOrderContract.maintenanceOrderId != 0) {
      this.maintenanceOrderService.downloadFileToMaintenanceOrder(this.maintenanceOrderContract.maintenanceOrderId, fileName).subscribe(data => {
        switch (data.type) {
          case HttpEventType.Response: {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = fileName;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
        }
      });
    }
  }


  async editMaintenanceOrder() {
    await this.getMaintenanceOrderById();
    this.validateForm(this.maintenanceOrderContract);
  }

  async getButtonClick(buttonClick: any) {
    const branchId = this.formMaintenanceOrder.get("branchId")?.value;
    const maintenanceOrderClassId = this.formMaintenanceOrder.get("maintenanceOrderClassId")?.value;
    let consecutive = this.formMaintenanceOrder.get("consecutive")?.value;
    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    }
    if (maintenanceOrderClassId == null || maintenanceOrderClassId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una clase O.M.'
      );
      return;
    }
    if (consecutive == "" || consecutive == null) consecutive = 0;

    const actionMap: Record<string, () => Promise<MaintenanceOrderModel>> = {
      first: async () =>
        await firstValueFrom(this.maintenanceOrderService.getFirstMaintenanceOrderByKeysAsync(branchId, maintenanceOrderClassId)),
      previus: async () =>
        await firstValueFrom(this.maintenanceOrderService.getPreviusMaintenanceOrderByKeysAsync(consecutive, branchId, maintenanceOrderClassId)),
      next: async () =>
        await firstValueFrom(this.maintenanceOrderService.getNextMaintenanceOrderByKeysAsync(consecutive, branchId, maintenanceOrderClassId)),
      last: async () =>
        await firstValueFrom(this.maintenanceOrderService.getLastMaintenanceOrderByKeysAsync(branchId, maintenanceOrderClassId)),
    };
    const errorMessages: Record<string, string> = {
      first: 'Error al buscar la primer orden de mantenimiento.',
      previus: 'Error al buscar la orden de mantenimiento anterior.',
      next: 'Error al buscar la orden de mantenimiento siguiente.',
      last: 'Error al buscar la ultima orden de mantenimiento.',
    };

    const action = actionMap[buttonClick.target.id];
    if (!action) return;

    try {
      this.maintenanceOrderContract = await action();
      this.maintenanceOrderId = this.maintenanceOrderContract.maintenanceOrderId;
      this.clientId = this.maintenanceOrderContract.clientId;
      this.branchId = this.maintenanceOrderContract.branchId;
      this.articleId = this.maintenanceOrderContract.articleId;
      this.storeId = this.maintenanceOrderContract.storeId;
      this.maintenanceOrderType = this.maintenanceOrderContract.maintenanceOrderTypeId;
      await this.getAllLists('costCenters');
      this.validateForm(this.maintenanceOrderContract);
      this.location.replaceState(`/maintenance-order/register/${this.maintenanceOrderId}`);
    } catch (error) {
      this.location.replaceState(`/maintenance-order/register`);
      console.error(errorMessages[buttonClick.target.id], error);
    }
  }

  async getAllLists(...listsToLoad: Array<'branches' | 'clients' | 'costCenters' | 'mechanics' | 'drivers' | 'vehicles'>) {
    try {
      const lists = {
        branches: async () => {
          this.listBranch = await firstValueFrom(
            this.branchService.getAllBranchesForSelectAsync()
          );
        },
        clients: async () => {
          this.listClient = await firstValueFrom(
            this.clientService.getAllClientsForSelectAsync()
          );
        },
        costCenters: async () => {
          const maintenanceOrderClass = this.maintenanceOrderContract.maintenanceOrderClassId;
          let service: Observable<any[]>;
          if (maintenanceOrderClass != null && maintenanceOrderClass == ClassMaintenanceOrderEnum.programada) {
            service = this.maintenanceOrderService.getAllCostCentersForSelectMaintenanceOrderAsync(this.branchId, this.clientId);
          } else {
            service = this.costCenterService.getAllCostCentersByKeysForSelectAsync(this.branchId, this.clientId, 0);
          }
          this.listCostCenter = await firstValueFrom(service);
        },
        mechanics: async () => {
          this.listMechanic = await firstValueFrom(
            this.mechanicService.getAllMechanicsForSelectAsync(this.branchId)
          );
          const defaultMechanic = this.listMechanic.find(x => x.isDefault);
          if (defaultMechanic) {
            this.mechanicId = defaultMechanic.value;
          }
        },
        drivers: async () => {
          this.listDriver = await firstValueFrom(
            this.transporterService.getAllTransportersForSelectAsync(this.branchId)
          );
          const defaultDriver = this.listDriver.find(x => x.isDefault);
          if (defaultDriver) {
            this.transporterId = defaultDriver.value;
          }
        },
        vehicles: async () => {
          this.listVehicle = await firstValueFrom(
            this.vehicleService.getAllVehiclesForSelectAsync(this.branchId)
          );
          const defaultVehicle = this.listVehicle.find((x: any) => x.isDefault);
          if (defaultVehicle) {
            this.vehicleId = defaultVehicle.value;
          }
        }
      };
      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.branches(),
          lists.clients(),
          lists.costCenters(),
          lists.mechanics(),
          lists.drivers(),
          lists.vehicles()
        ]);
      }
      if (this.maintenanceOrderClass != null && this.maintenanceOrderClass != undefined && this.maintenanceOrderClass != 0) {
        this.listTypeMaintenanceOrderForClass = this.listTypeMaintenanceOrder.filter(item => item.class == this.maintenanceOrderClass);
      } else {
        this.listTypeMaintenanceOrderForClass = [];
      }
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  async getArticle(articleId: number) {
    if (articleId != 0 && articleId != null) {
      try {
        const article = await firstValueFrom(this.articleService.getArticleById(articleId));
        if (article) this.articleCodeName = `${article.code} - ${article.name}`;
      } catch (error) {
        this.articleCodeName = 'Error al buscar el artículo';
        console.error('Error al buscar el artículo por Id.', error);
      }
    }
  }

  async getCostCenterById(costCenterId: number): Promise<CostCenterModel | null> {
    if (costCenterId == null || costCenterId == 0) return null;
    try {
      return await firstValueFrom(this.costCenterService.getCostCenterById(costCenterId));
    } catch (error) {
      console.error('Error al obtener el centro de costos por Id.', error);
      return null;
    }
  }

  async getColumnsEquipmentSelection() {
    try {
      this.headersEquipmentSelection = await firstValueFrom(this.maintenanceOrderService.getColumnsForEquipmentAsync(this.maintenanceOrderType));
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getColumnsInvoices() {
    try {
      if (this.headersInvoices.length > 0) return;
      this.headersInvoices = await firstValueFrom(this.invoiceService.getColumnsForInvoicesByClientAsync());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getAllEquipmentSelectionAsync() {
    try {
      this.equipmentSelectionData = await firstValueFrom(this.maintenanceOrderService.getEquipmentAsync(this.page, this.limit,
        this.columnSort, this.ascendant, this.costCenterId, this.maintenanceOrderType, this.filtersEquipmentSelection));
      this.updateInputsForSelectEquipmentModal();
    } catch (error) {
      console.error('Error al obtener la lista de los equipos', error);
    }
  }

  async getAllInvoicesForMaintenanceOrderAsync() {
    try {
      this.invoicesData = await firstValueFrom(this.invoiceService.getInvoicesByClientIdAsync(this.maintenanceOrderContract.clientId, this.pageInvoice, this.limitInvoice,
        this.columnSortInvoice, this.ascendantInvoice, this.filtersInvoices));
      this.updateInputsForInvoicesSelection();
    } catch (error) {
      console.error('Error al obtener la lista de las facturas', error);
    }
  }

  async getCurrentNoteStage() {
    try {
      this.noteStageCurrent = await firstValueFrom(this.maintenanceOrderService.getCurrentNoteStage(this.maintenanceOrderId));
    } catch (error) {
      console.error('Error al buscar la etapa de notas actual.', error);
    }
  }

  async getFilesToMaintenanceOrder() {
    try {
      this.listFiles = await firstValueFrom(this.maintenanceOrderService.getFilesToMaintenanceOrder(this.maintenanceOrderId));
      this.updateInputsForAttachFiles();
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    const mainBranchByUser = await firstValueFrom(
      this.userAuthenticatedService.branchObservable.pipe(
        filter(branch => branch && branch.branchId !== 0)
      )
    );
    this.branchId = mainBranchByUser.branchId;
    this.companyId = mainBranchByUser.companyId;
    await this.getAllLists();
  }


  async getSuspensionByMaintenanceOrderAsync(maintenanceOrderId: number): Promise<SuspensionModel | null> {
    try {
      return await firstValueFrom(
        this.maintenanceOrderService.getSuspensionByMaintenanceOrderAsync(maintenanceOrderId)
      );
    } catch (error) {
      console.error('Error al buscar la suspensión de la orden de mantenimiento.', error);
      return null;
    }
  }

  async getAssociatedSuspensionAsync(maintenanceOrder: MaintenanceOrderModel) {
    const isOwnEquipmentOnSite = maintenanceOrder.maintenanceOrderTypeId === TypeMaintenanceOrderEnum.equipoPropioEnObra &&
      maintenanceOrder.maintenanceOrderClassId === ClassMaintenanceOrderEnum.enSitio;

    if (!isOwnEquipmentOnSite || !maintenanceOrder.maintenanceOrderId) {
      this.suspensionConsecutive = '';
      this.suspensionId = 0;
      return;
    }

    const maintenanceOrderId = maintenanceOrder.maintenanceOrderId;
    const suspension = await this.getSuspensionByMaintenanceOrderAsync(maintenanceOrderId);
    if (this.maintenanceOrderContract.maintenanceOrderId !== maintenanceOrderId) {
      return;
    }

    if (suspension && suspension.suspensionId) {
      this.suspensionId = suspension.suspensionId;
      this.suspensionConsecutive = suspension.consecutive != null ? suspension.consecutive.toString() : '';
    } else {
      this.suspensionConsecutive = '';
      this.suspensionId = 0;
    }
  }

  async getAssociatedDevolutionAsync(maintenanceOrder: MaintenanceOrderModel) {
    this.devolutionConsecutive = maintenanceOrder.devolutionConsecutive != null
      ? maintenanceOrder.devolutionConsecutive.toString()
      : '';

    if (!maintenanceOrder.devolutionDetailId) {
      this.devolutionId = 0;
      return;
    }

    const devolutionDetailId = maintenanceOrder.devolutionDetailId;
    try {
      const devolutionDetail = await firstValueFrom(
        this.devolutionDetailService.getDevolutionDetailById(devolutionDetailId)
      );

      if (this.maintenanceOrderContract.devolutionDetailId !== devolutionDetailId) {
        return;
      }

      this.devolutionId = devolutionDetail && devolutionDetail.devolutionId ? devolutionDetail.devolutionId : 0;
    } catch (error) {
      console.error('Error al resolver la devolución de la orden de mantenimiento.', error);
      this.devolutionId = 0;
    }
  }

  async manageSuspensionAsync() {
    const { maintenanceOrderTypeId, maintenanceOrderClassId } = this.formMaintenanceOrder.value;
    const isOwnEquipmentOnSite = maintenanceOrderTypeId === TypeMaintenanceOrderEnum.equipoPropioEnObra &&
      maintenanceOrderClassId === ClassMaintenanceOrderEnum.enSitio;
    if (!(isOwnEquipmentOnSite) || !this.swGenerateSuspensionsOM) {
      return;
    }

    const maintenanceOrderId = this.maintenanceOrderContract.maintenanceOrderId;
    const existingSuspension = await this.getSuspensionByMaintenanceOrderAsync(maintenanceOrderId);
    if (!existingSuspension && !(await this.confirmDialogService.confirm('¿Desea crear una suspensión para el equipo?'))) {
      return;
    }

    try {
      const suspension = await firstValueFrom(this.maintenanceOrderService.manageSuspensionAsync(maintenanceOrderId));
      this.suspensionId = suspension.suspensionId;
      this.suspensionConsecutive = suspension.consecutive != null ? suspension.consecutive.toString() : '';
      this.toastHandlerService.showToast(
        'success',
        `La suspensión ${suspension.consecutive} fue ${existingSuspension ? 'actualizada' : 'creada'} exitosamente.`
      );
    } catch (error) {
      console.error('Error al generar la suspensión para el equipo.', error);
    }
  }

  async hasSuspensionInInvoicingCutoffAsync() {
    const { maintenanceOrderTypeId, maintenanceOrderClassId } = this.formMaintenanceOrder.value;
    const isOwnEquipmentOnSite = maintenanceOrderTypeId === TypeMaintenanceOrderEnum.equipoPropioEnObra &&
      maintenanceOrderClassId === ClassMaintenanceOrderEnum.enSitio;

    if (!isOwnEquipmentOnSite || !this.swGenerateSuspensionsOM || !this.maintenanceOrderContract.maintenanceOrderId)
      return false;

    const suspension = await this.getSuspensionByMaintenanceOrderAsync(this.maintenanceOrderContract.maintenanceOrderId);
    if (suspension && suspension.invoicingCutoffId && suspension.invoicingCutoffId > 0) {
      this.toastHandlerService.showToast(
        'error',
        'La orden de mantenimiento tiene una suspensión dentro de un corte de facturación, no se permite modificar este valor.'
      );
      return true;
    }
    return false;
  }

  async getGeneralParametersByCompany() {
    return new Promise((resolve) => {
      this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
        this.swMaintenanceOrderScheduled = response.some(x => x.name === "OrdenMatenimientoProgramada");
        this.swGenerateSuspensionsOM = response.some(x => x.generalParameterId === GeneralParameterEnums.generarSuspensionesOM);
        if (this.swMaintenanceOrderScheduled) {
          this.listClassMaintenanceOrder.push({ label: 'Programada', value: ClassMaintenanceOrderEnum.programada });
          this.listTypeMaintenanceOrder.push({ label: 'Programado', value: TypeMaintenanceOrderEnum.mantenimientoProgramado, class: ClassMaintenanceOrderEnum.programada })
          this.getFormatMaintenanceOrderScheduled();
        }
      });
      resolve(true);
    });
  }

  async getMaintenanceOrderById() {
    try {
      this.maintenanceOrderContract = await firstValueFrom(this.maintenanceOrderService.getMaintenanceOrderById(this.maintenanceOrderId));
      this.maintenanceOrderId = this.maintenanceOrderContract.maintenanceOrderId;
      this.clientId = this.maintenanceOrderContract.clientId;
      this.branchId = this.maintenanceOrderContract.branchId;
      this.articleId = this.maintenanceOrderContract.articleId;
      this.storeId = this.maintenanceOrderContract.storeId;
      this.maintenanceOrderType = this.maintenanceOrderContract.maintenanceOrderTypeId;
      await this.getAllLists();
    } catch (error) {
      console.error('Error al buscar la orden de mantenimiento por Id.', error);
    }
  }

  async getMaintenancePlansByArticleAsync(articleId: number) {
    try {
      this.listMaintenancePlans = await firstValueFrom(this.maintenanceStrategyService.getMaintenancePlansByArticleAsync(articleId));
    } catch (error) {
      console.error('Error al buscar los planes de mantenimiento por articulo.', error);
    }
  }

  async getEquipmentLogbookByArticleIdAsync(articleId: number) {
    try {
      const equipmentLogbook = await firstValueFrom(this.equipmentLogbookService.getEquipmentLogbookByArticleIdAsync(articleId));
      if (equipmentLogbook.unitId) {
        this.equipmentLogbookUnitId = equipmentLogbook.unitId;
      } else {
        this.toastHandlerService.showToast(
          'warning',
          `El articulo seleccionado no tiene de medida unidad en la hoja de vida`
        );
      }
    } catch (error) {
      console.error('Error al buscar el libro de equipos por articulo.', error);
    }
  }

  async getFormatMaintenanceOrderScheduled() {
    try {
      this.formatScheduled = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId, FormatsEnums.maintenanceOrderScheduled));
    } catch (error) {
      console.error('Error al buscar el formato de orden de mantenimiento programada.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }

    await this.getPermissionsForUserByWindow();
    await this.getGeneralParametersByCompany();

    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      this.inputsForModals$.next({
        maintenanceOrderId: this.maintenanceOrderContract.maintenanceOrderId,
        maintenanceOrderClassId: this.maintenanceOrderContract.maintenanceOrderClassId,
        permissionUpdatable: this.permissionUpdatable,
        maintenanceOrderStateId: this.maintenanceOrderContract.maintenanceOrderStateId,
        swCostRepairState: this.maintenanceOrderContract.swCostRepairState,
        swBlock: this.maintenanceOrderContract.swBlock
      });
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.companyId = this.userAuthenticated.companyId;
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.MaintenanceOrder));
  }

  async getStore(storeId: number | null) {
    if (storeId != 0 && storeId != null) {
      try {
        const store = await firstValueFrom(this.storeService.getStoreById(storeId));
        if (store) this.storeCodeName = `${store.code} - ${store.name}`;
      } catch (error) {
        this.storeCodeName = 'Error al buscar la bodega';
        console.error('Error al buscar la bodega por Id.', error);
      }
    }
  }

  async getTotalMaintenanceOrderActivities() {
    try {
      this.totalMaintenanceOrderActivities = await firstValueFrom(this.maintenanceOrderActivitiesService.getTotalMaintenanceOrderActivitiesAsync(this.maintenanceOrderContract.maintenanceOrderId));
    } catch (error) {
      console.error('Error al buscar el total de actividades de la orden de mantenimiento.', error);
    }
  }

  async getUnitHours() {
    try {
      const unitHours = await firstValueFrom(this.unitService.getUnitByCode(UnitCode.unitHour));
      this.unitHoursId = unitHours.unitId;
    } catch (error) {
      console.error('Error al buscar las horas de la unidad.', error);
    }
  }

  async handleInitialState() {
    if (this.maintenanceOrderId !== null && this.maintenanceOrderId !== 0) {
      await this.editMaintenanceOrder();
    } else {
      await this.getFirstBranchByUserAuthenticatedAsync();
      this.createNewMaintenanceOrder(false);
    }
  }

  async handleSelectedItem(selectedItem: any) {
    const [selected] = selectedItem;
    this.formMaintenanceOrder.patchValue({ invoiceNumber: selected.consecutive, valueToInvoiced: selected.subtotalValue });
  }

  async onFilterChangeEquipment(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersEquipmentSelection = this.removeDuplicates(filters);
    this.filtersEquipmentSelection.forEach((filter: any) => this.processFilter(filter));
    this.updateInputsForSelectEquipmentModal();
  }

  async onPageChangeEquipment(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getAllEquipmentSelectionAsync();
  }

  async onFilterChangeInvoice(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersInvoices = this.removeDuplicates(filters);
    this.filtersInvoices.forEach((filter: any) => this.processFilter(filter));
    this.updateInputsForInvoicesSelection();
  }

  async onPageChangeInvoice(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageInvoice = event.page;
    this.limitInvoice = event.pageSize;
    this.columnSortInvoice = event.sortField || null;
    this.ascendantInvoice = event.sortOrder === 1;
    this.getAllInvoicesForMaintenanceOrderAsync();
  }

  onSelectMaintenancePlan(event: any) {
    if (this.maintenanceOrderContract.maintenanceOrderId !== null && this.maintenanceOrderContract.maintenanceOrderId !== 0 && this.totalMaintenanceOrderActivities > 0) {
      this.formMaintenanceOrder.get("maintenancePlan")?.patchValue(this.maintenanceOrderContract.maintenancePlan);
      this.toastHandlerService.showToast(
        'warning',
        'No es posible cambiar el plan de mantenimiento, existen actividades registradas.'
      );
      return;
    }
    this.formMaintenanceOrder.get("interval")?.patchValue(event);
  }

  async openEquipmentSelectionModal() {
    if (await this.hasSuspensionInInvoicingCutoffAsync()) return;

    if ((this.maintenanceOrderContract.maintenanceOrderId != 0 && this.maintenanceOrderContract.maintenanceOrderStateId == MaintenanceOrderEnums.abierta) ||
      this.maintenanceOrderContract.maintenanceOrderId == 0) {
      const maintenanceOrderTypeId = this.formMaintenanceOrder.get("maintenanceOrderTypeId")?.value;
      if (maintenanceOrderTypeId && maintenanceOrderTypeId != 0) {
        if (maintenanceOrderTypeId == TypeMaintenanceOrderEnum.equipoPropioEnObra) {
          if (this.costCenterId == 0 || this.costCenterId == null) {
            this.toastHandlerService.showToast(
              'warning',
              'Seleccione un centro de costos.'
            );
            return;
          }
        } else if (maintenanceOrderTypeId == TypeMaintenanceOrderEnum.mantenimientoProgramado && this.totalMaintenanceOrderActivities > 0) {
          this.toastHandlerService.showToast(
            'warning',
            'No es posible modificar el equipo, existen actividades registradas.'
          );
          return;
        }
        this.filtersEquipmentSelection = [];
        await Promise.all([
          this.getColumnsEquipmentSelection(),
          this.getAllEquipmentSelectionAsync()]
        );
        this.updateInputsForSelectEquipmentModal();
        this.equipmentSelectionModalComponent && this.equipmentSelectionModalComponent.show();
      } else {
        this.toastHandlerService.showToast(
          'warning',
          'Seleccione un tipo de orden de mantenimiento.'
        );
        return;
      }
    } else {
      this.toastHandlerService.showToast(
        'error',
        'Para modificar el equipo, la orden de mantenimiento debe estar abierta.'
      );
    }
  }

  async openAttachFile() {
    if (this.maintenanceOrderContract.maintenanceOrderId != 0 && this.maintenanceOrderContract.maintenanceOrderId != null) {
      await this.getFilesToMaintenanceOrder();
      this.attachFileMaintenanceOrderComponent && this.attachFileMaintenanceOrderComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una orden de mantenimiento.'
      );
    }
  }

  openNotesModal() {
    if (this.maintenanceOrderContract.maintenanceOrderId != 0 && this.maintenanceOrderContract.maintenanceOrderId != null) {
      this.noteStageModalComponent && this.noteStageModalComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una orden de mantenimiento.'
      );
    }
  }

  async openSelectionInvoiceModal() {
    if (this.maintenanceOrderContract.maintenanceOrderId != 0 && this.maintenanceOrderContract.maintenanceOrderId != null) {
      await Promise.all([
        this.getColumnsInvoices(),
        this.getAllInvoicesForMaintenanceOrderAsync()
      ]);
      this.updateInputsForInvoicesSelection();
      this.invoiceSelectionModalComponent && this.invoiceSelectionModalComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una orden de mantenimiento.'
      );
    }
  }

  openRepairsModal() {
    if (this.maintenanceOrderContract.maintenanceOrderId != 0 && this.maintenanceOrderContract.maintenanceOrderId != null) {
      this.repairModalComponent && this.repairModalComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una orden de mantenimiento.'
      );
    }
  }

  openMaintenanceActivitiesModal() {
    if (this.maintenanceOrderContract.maintenanceOrderId != 0 && this.maintenanceOrderContract.maintenanceOrderId != null) {
      this.inputsForMaintenanceOrderActivitiesModal$.next({
        maintenanceOrderModel: this.maintenanceOrderContract,
        permissionUpdatable: this.permissionUpdatable
      });
      this.maintenanceOrderActivitiesModalComponent && this.maintenanceOrderActivitiesModalComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una orden de mantenimiento.'
      );
    }
  }

  openMaintenanceSuppliesModal() {
    if (this.maintenanceOrderContract.maintenanceOrderId != 0 && this.maintenanceOrderContract.maintenanceOrderId != null) {
      this.inputsForMaintenanceOrderSuppliesModal$.next({
        maintenanceOrderModel: this.maintenanceOrderContract,
        permissionUpdatable: this.permissionUpdatable
      });

      this.maintenanceOrderSuppliesModalComponent && this.maintenanceOrderSuppliesModalComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una orden de mantenimiento.'
      );
    }
  }

  finishPrintMaintenanceOrder(finishPrint: boolean) {
    if (finishPrint) window.print();
  }

  // openToggle(event: any) {
  //   this.informationPopover.toggle(event);
  // }

  async onSave() {
    if (!this.formMaintenanceOrder.valid) {
      this.showValidationMessages();
      return;
    }
    try {
      const branchId = this.formMaintenanceOrder.get("branchId")?.value;
      const maintenanceOrderClassId = this.formMaintenanceOrder.get("maintenanceOrderClassId")?.value;
      const response = await firstValueFrom(this.maintenanceOrderService.hasExistingMaintenanceOrder(branchId, maintenanceOrderClassId));
      if (!response) {
        this.initialConsecutiveModalComponent?.show();
        return;
      }
      await this.send();
    } catch (error) {
      console.error('Error al buscar el ultimo traslado.', error);
    }
  }

  async printMaintenanceOrder(onBlank: boolean) {
    this.toastHandlerService.clearAllToasts();
    this.printOmOnBlank = onBlank;
    if (this.maintenanceOrderContract.maintenanceOrderId != 0 && this.maintenanceOrderContract.maintenanceOrderId != null) {
      if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.imprimir)) {
        if (this.enabledPrint) {
          if (this.permissionPrint) {
            this.toastHandlerService.clearAllToasts();
            try {
              if (this.maintenanceOrderContract.maintenanceOrderClassId == ClassMaintenanceOrderEnum.programada) {
                this.maintenanceOrderPrintModel = await firstValueFrom(this.maintenanceOrderService.getMaintenanceOrderScheduledByKeysByPrintAsync(
                  this.maintenanceOrderContract.consecutive, this.maintenanceOrderContract.branchId, this.printOmOnBlank));
                this.reloadPrintScheduled = !this.reloadPrintScheduled;
              } else {
                this.maintenanceOrderPrintModel = await firstValueFrom(this.maintenanceOrderService.getMaintenanceOrderByKeysByPrintAsync(
                  this.maintenanceOrderContract.consecutive, this.maintenanceOrderContract.branchId, this.maintenanceOrderContract.maintenanceOrderClassId));
                if (this.maintenanceOrderContract.maintenanceOrderClassId == ClassMaintenanceOrderEnum.enSitio) {
                  this.reloadPrintSite = !this.reloadPrintSite;
                } else {
                  this.reloadPrintWorkshop = !this.reloadPrintWorkshop;
                }
              }
            } catch (error) {
              console.error('Error al actualizar el estado de la orden de mantenimiento a imprimir:', error);
            }
          } else {
            this.toastHandlerService.showToast(
              'error',
              'El usuario no tiene permisos para imprimir ordenes de mantenimiento. Comuníquese con el administrador del sistema.'
            );
          }
        }
      } else {
        this.toastHandlerService.showToast(
          'error',
          'El usuario no tiene permisos para imprimir ordenes de mantenimiento. Comuníquese con el administrador del sistema.'
        );
        return;
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una orden de mantenimiento.'
      );
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersEquipmentSelection = this.filtersEquipmentSelection.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersEquipmentSelection.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  async reloadMaintenanceOrder(params: any) {
    if (params.reload) {
      await this.getMaintenanceOrderById();
      this.validateForm(this.maintenanceOrderContract);
    }
  }

  reloadWindow(event: Event) {
    event.preventDefault();
    if (this.maintenanceOrderId != 0 && this.maintenanceOrderId != null) {
      this.router.navigate(['/maintenance-order/register/', this.maintenanceOrderId]);
    } else {
      this.router.navigate(['/maintenance-order/register']);
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async reverseState() {
    if (this.maintenanceOrderId != 0 && this.maintenanceOrderId != null) {
      const canUpdate = await this.validatePermissionUpdatable();
      if (!canUpdate) return;
      if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.abrir)) {
        const oldMaintenanceOrderStateId = this.maintenanceOrderStateId;
        switch (this.maintenanceOrderStateId) {
          case MaintenanceOrderEnums.cierreInicial: {
            this.maintenanceOrderStateId = MaintenanceOrderEnums.abierta;

            //Validar que la fecha final del diagnóstico sea mayor a la fecha inicial del diagnóstico
            const dateInitial = this.dateConverterService.convertUtcToLocalDate(this.formMaintenanceOrder.get('dateInitialMaintenanceOrder')?.value);
            const dateFinal = this.dateConverterService.convertUtcToLocalDate(this.formMaintenanceOrder.get('dateFinalMaintenanceOrder')?.value);
            this.maintenanceOrderContract.dateFinalMaintenanceOrder = dateFinal;
            if (dateFinal.getTime() < dateInitial.getTime()) {
              this.toastHandlerService.showToast(
                'warning',
                'La fecha final del diagnóstico debe ser mayor a la fecha inicial.'
              );
              return;
            }

            break;
          }
          case MaintenanceOrderEnums.cierreFinal: {
            if (this.maintenanceOrderContract.maintenanceOrderClassId == ClassMaintenanceOrderEnum.enTaller) {
              this.maintenanceOrderStateId = MaintenanceOrderEnums.cierreInicial;
            } else {
              this.maintenanceOrderStateId = MaintenanceOrderEnums.abierta;
            }
            break;
          }
        }
        try {
          this.maintenanceOrderContract.maintenanceOrderStateId = this.maintenanceOrderStateId;
          this.maintenanceOrderContract = await firstValueFrom(this.maintenanceOrderService.updateMaintenanceOrder(this.maintenanceOrderContract));
          this.validateForm(this.maintenanceOrderContract);
          this.toastHandlerService.showToast(
            'success',
            'La orden de mantenimiento fue modificada exitosamente.'
          );
        } catch (error) {
          this.maintenanceOrderStateId = oldMaintenanceOrderStateId;
          this.maintenanceOrderContract.maintenanceOrderStateId = oldMaintenanceOrderStateId;
          console.error('Error al actualizar el estado de la orden de mantenimiento.', error);
        }
      } else {
        this.toastHandlerService.showToast(
          'error',
          'El usuario no tiene permisos para revertir estados de la orden de mantenimiento. Comuníquese con el administrador del sistema.'
        );
        return;
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una orden de mantenimiento.'
      );
    }
  }

  async send() {
    const canUpdate = await this.validatePermissionUpdatable();
    if (!canUpdate) return;
    Object.keys(this.formMaintenanceOrder.controls).forEach(key => {
      const control = this.formMaintenanceOrder.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, control.value);
      }
    });
    if (this.formMaintenanceOrder.valid) {
      const formValues = this.formMaintenanceOrder.getRawValue();
      const dateMaintenanceOrder = formValues.dateMaintenanceOrder ?
        this.dateConverterService.convertUtcToLocalDate(formValues.dateMaintenanceOrder) : null;

      if (dateMaintenanceOrder) {
        if (formValues.dateCompromise) {
          const dateCompromise = this.dateConverterService.convertUtcToLocalDate(formValues.dateCompromise);
          if (dateCompromise.getTime() < dateMaintenanceOrder.getTime()) {
            this.toastHandlerService.showToast(
              'warning',
              'La fecha de compromiso debe ser mayor a la fecha de la orden de mantenimiento.'
            );
            return;
          }
        }
        if (formValues.dateInitialMaintenanceOrder) {
          const dateInitial = this.dateConverterService.convertUtcToLocalDate(formValues.dateInitialMaintenanceOrder);
          if (dateInitial.getTime() < dateMaintenanceOrder.getTime()) {
            this.toastHandlerService.showToast(
              'warning',
              'La fecha inicial del diagnóstico debe ser mayor a la fecha de la orden de mantenimiento.'
            );
            return;
          }
        }

        if (formValues.dateInitialMaintenanceOrder && formValues.dateFinalMaintenanceOrder) {
          const dateInitial = this.dateConverterService.convertUtcToLocalDate(formValues.dateInitialMaintenanceOrder);
          const dateFinal = this.dateConverterService.convertUtcToLocalDate(formValues.dateFinalMaintenanceOrder);
          if (dateFinal.getTime() < dateInitial.getTime()) {
            this.toastHandlerService.showToast(
              'warning',
              'La fecha final del diagnóstico debe ser mayor a la fecha inicial.'
            );
            return;
          }
        }
      }

      //Valido que las propiedades fuera del formulario no sean nulas o cero
      if (this.articleId == 0 || this.articleId == null) {
        this.toastHandlerService.showToast(
          'warning',
          'El campo equipo es obligatorio.'
        );
        return;
      }
      //Habilito el formulario para poder obtener los datos
      this.formMaintenanceOrder.enable();
      const modelMaintenanceOrder = this.formMaintenanceOrder.getRawValue() as MaintenanceOrderModel;
      if (modelMaintenanceOrder.maintenanceOrderTypeId == TypeMaintenanceOrderEnum.equipoPropioDeAlmacen) {
        if (this.storeId == 0 || this.storeId == null) {
          this.toastHandlerService.showToast(
            'warning',
            'El campo bodega es obligatorio.'
          );
          return;
        }
      }
      if (modelMaintenanceOrder.maintenanceOrderClassId == ClassMaintenanceOrderEnum.enSitio && modelMaintenanceOrder.dateCompromise == null) {
        this.toastHandlerService.showToast(
          'warning',
          'El campo compromiso es obligatorio.'
        );
        return;
      }

      if (modelMaintenanceOrder.maintenanceOrderClassId == ClassMaintenanceOrderEnum.programada && modelMaintenanceOrder.maintenancePlan == null) {
        this.toastHandlerService.showToast(
          'warning',
          'El campo Plan Mtto. es obligatorio.'
        );
        return;
      }
      //Hago null, los campos que permiten ser nulos:
      if (modelMaintenanceOrder.initialDiagnosis && modelMaintenanceOrder.initialDiagnosis.trim() === "") modelMaintenanceOrder.initialDiagnosis = null;
      if (modelMaintenanceOrder.finalDiagnosis && modelMaintenanceOrder.finalDiagnosis.trim() === "") modelMaintenanceOrder.finalDiagnosis = null;
      if (modelMaintenanceOrder.reportedBy && modelMaintenanceOrder.reportedBy.trim() === "") modelMaintenanceOrder.reportedBy = null;
      if (modelMaintenanceOrder.contactConstructionSite && modelMaintenanceOrder.contactConstructionSite.trim() === "") modelMaintenanceOrder.contactConstructionSite = null;
      if (modelMaintenanceOrder.receivedBy && modelMaintenanceOrder.receivedBy.trim() === "") modelMaintenanceOrder.receivedBy = null;
      if (modelMaintenanceOrder.costCenterId == 0) modelMaintenanceOrder.costCenterId = null;
      if (modelMaintenanceOrder.swDeliveredOnTime == null) modelMaintenanceOrder.swDeliveredOnTime = null;
      modelMaintenanceOrder.maintenanceOrderStateId = MaintenanceOrderEnums.abierta;
      //Asigno los valores en las variables fuera del formulario
      modelMaintenanceOrder.articleId = this.articleId;
      modelMaintenanceOrder.storeId = this.storeId;
      if (this.maintenanceOrderId == 0) {
        try {
          this.maintenanceOrderContract = await firstValueFrom(this.maintenanceOrderService.createMaintenanceOrder(modelMaintenanceOrder));
          this.maintenanceOrderId = this.maintenanceOrderContract.maintenanceOrderId;
          this.validateForm(this.maintenanceOrderContract);
          this.toastHandlerService.showToast(
            'success',
            'La orden de mantenimiento fue creada exitosamente.'
          );
          this.location.replaceState(`/maintenance-order/register/${this.maintenanceOrderId}`);
        } catch (error) {
          this.updateFormState(modelMaintenanceOrder);
          console.error('Error al crear la orden de mantenimiento.', error);
        }
      } else {
        this.maintenanceOrderContract.alterNumber = modelMaintenanceOrder.alterNumber;
        this.maintenanceOrderContract.dateMaintenanceOrder = modelMaintenanceOrder.dateMaintenanceOrder;
        this.maintenanceOrderContract.maintenanceOrderTypeId = modelMaintenanceOrder.maintenanceOrderTypeId;
        this.maintenanceOrderContract.maintenanceOrderStateId = this.maintenanceOrderStateId;
        this.maintenanceOrderContract.workshopType = modelMaintenanceOrder.workshopType;
        this.maintenanceOrderContract.clientId = modelMaintenanceOrder.clientId;
        this.maintenanceOrderContract.costCenterId = modelMaintenanceOrder.costCenterId;
        this.maintenanceOrderContract.articleId = this.articleId;
        this.maintenanceOrderContract.storeId = this.storeId;
        this.maintenanceOrderContract.mechanicId = modelMaintenanceOrder.mechanicId;
        this.maintenanceOrderContract.maintenanceTypeId = modelMaintenanceOrder.maintenanceTypeId;
        this.maintenanceOrderContract.dateInitialMaintenanceOrder = modelMaintenanceOrder.dateInitialMaintenanceOrder;
        this.maintenanceOrderContract.initialDiagnosis = modelMaintenanceOrder.initialDiagnosis;
        this.maintenanceOrderContract.dateFinalMaintenanceOrder = modelMaintenanceOrder.dateFinalMaintenanceOrder;
        this.maintenanceOrderContract.finalDiagnosis = modelMaintenanceOrder.finalDiagnosis;
        this.maintenanceOrderContract.repairHour = modelMaintenanceOrder.repairHour;
        this.maintenanceOrderContract.kmHoromValue = modelMaintenanceOrder.kmHoromValue;
        this.maintenanceOrderContract.reportedBy = modelMaintenanceOrder.reportedBy;
        this.maintenanceOrderContract.receivedBy = modelMaintenanceOrder.receivedBy;
        this.maintenanceOrderContract.contactConstructionSite = modelMaintenanceOrder.contactConstructionSite;
        this.maintenanceOrderContract.dateCompromise = modelMaintenanceOrder.dateCompromise;
        this.maintenanceOrderContract.swDeliveredOnTime = modelMaintenanceOrder.swDeliveredOnTime;
        this.maintenanceOrderContract.qualificationId = modelMaintenanceOrder.qualificationId;
        this.maintenanceOrderContract.transporterId = modelMaintenanceOrder.transporterId;
        this.maintenanceOrderContract.vehicleId = modelMaintenanceOrder.vehicleId;
        this.maintenanceOrderContract.transportValue = modelMaintenanceOrder.transportValue;
        this.maintenanceOrderContract.invoiceNumber = modelMaintenanceOrder.invoiceNumber;
        this.maintenanceOrderContract.valueToInvoiced = modelMaintenanceOrder.valueToInvoiced;
        this.maintenanceOrderContract.swChargeConstructionSite = modelMaintenanceOrder.swChargeConstructionSite;
        this.maintenanceOrderContract.transportValueToPay = modelMaintenanceOrder.transportValueToPay;
        this.maintenanceOrderContract.costRepairValue = modelMaintenanceOrder.costRepairValue;
        this.maintenanceOrderContract.maintenancePlan = modelMaintenanceOrder.maintenancePlan;
        this.maintenanceOrderContract.interval = modelMaintenanceOrder.interval;
        this.maintenanceOrderContract.devolutionDetailId = modelMaintenanceOrder.devolutionDetailId;
        try {
          this.maintenanceOrderContract = await firstValueFrom(this.maintenanceOrderService.updateMaintenanceOrder(this.maintenanceOrderContract));
          this.toastHandlerService.showToast(
            'success',
            'La orden de mantenimiento fue modificada exitosamente.'
          );
          this.validateForm(this.maintenanceOrderContract);
        } catch (error) {
          this.updateFormState(modelMaintenanceOrder);
          console.error('Error al actualizar la orden de mantenimiento.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  async setArticleStore(selectedItems: any) {
    const article = selectedItems[0];
    this.articleCodeName = `${article.code} - ${article.name}`;
    this.articleId = article.articleId;
    this.storeCodeName = `${article.storeCode} - ${article.storeName}`;
    this.storeId = article.storeId;
    if (this.maintenanceOrderContract.maintenanceOrderClassId == ClassMaintenanceOrderEnum.programada) {
      this.getMaintenancePlansByArticleAsync(this.articleId);
      await this.getEquipmentLogbookByArticleIdAsync(this.articleId);
    } else if (this.maintenanceOrderType == TypeMaintenanceOrderEnum.equipoPropioDeObra) {
      this.formMaintenanceOrder.get('costCenterId')?.patchValue(article.costCenterId);
      this.formMaintenanceOrder.get('devolutionDetailId')?.patchValue(article.devolutionDetailId);
      this.formMaintenanceOrder.get('workshopType')?.patchValue(article.workShopType);
      this.changeCostCenter(article.costCenterId);
      this.maintenanceOrderContract.devolutionConsecutive = article.devolutionConsecutive;
      this.maintenanceOrderContract.devolutionDetailId = article.devolutionDetailId;
      this.getAssociatedDevolutionAsync(this.maintenanceOrderContract);
    }
  }

  async onArticleValueChange(value: any) {
    if (value === null) {
      const isMaintenanceOrderActive = this.maintenanceOrderContract.maintenanceOrderId == 0 ||
        this.maintenanceOrderContract.maintenanceOrderStateId == MaintenanceOrderEnums.abierta;

      if (!isMaintenanceOrderActive) {
        this.toastHandlerService.showToast(
          'error',
          'Para modificar el equipo, la orden de mantenimiento debe estar abierta.'
        );
        return;
      }

      if (await this.hasSuspensionInInvoicingCutoffAsync()) return;
      this.articleId = 0;
      this.articleCodeName = '';
      this.storeCodeName = '';
      this.storeId = 0;
    }
  }

  showValidationMessages() {
    const controlMessages: any = {
      branchId: 'El campo Sucursal es obligatorio.',
      maintenanceOrderClassId: 'El campo Clase O.M. es obligatorio.',
      maintenanceOrderTypeId: 'El campo Tipo O.M. es obligatorio.',
      dateMaintenanceOrder: 'El campo Fecha O.M. es obligatorio.',
      maintenanceTypeId: 'El campo Tipo Mmto. es obligatorio.',
      workshopType: 'El campo Tipo Taller es obligatorio.',
      clientId: 'El campo Cliente es obligatorio.',
      mechanicId: 'El campo Mecánico es obligatorio.',
      initialDiagnosis: 'El campo Diagnóstico Ini. no puede tener más de 500 caracteres.',
      finalDiagnosis: 'El campo Diagnóstico Fin. no puede tener más de 500 caracteres.',
      reportedBy: 'El campo Reportado por, no puede tener más de 50 caracteres.',
      receivedBy: 'El campo Recibido por, no puede tener más de 50 caracteres.',
      contactConstructionSite: 'El campo Contacto obra, no puede tener más de 50 caracteres.',
      dateCompromise: 'El campo Compromiso es obligatorio.',
      maintenancePlan: 'El campo Plan Mtto. es obligatorio.',
      kmHoromValue: 'El campo Horómetro/Odómetro es obligatorio.',
    };
    Object.keys(controlMessages).forEach(control => {
      if (this.formMaintenanceOrder.controls[control].invalid) {
        this.toastHandlerService.showToast('warning', controlMessages[control], 'Atención');
      }
    });
  }

  updateInputsForSelectEquipmentModal() {
    this.inputsForSelectEquipmentModal$.next({
      headers: this.headersEquipmentSelection,
      data: this.equipmentSelectionData,
      filters: this.filtersEquipmentSelection,
      showCheckbox: true,
      showRecover: true,
      limitPaginator: true,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]
    });
  }

  updateInputsForInvoicesSelection() {
    this.inputsForInvoicesSelection$.next({
      headers: this.headersInvoices,
      data: this.invoicesData,
      filters: this.filtersInvoices,
      showCheckbox: true,
      showRecover: true
    });
  }

  async uploadFile(formData: any) {
    try {
      await firstValueFrom(this.maintenanceOrderService.attachFilesToMaintenanceOrder(this.maintenanceOrderId, formData));
      await this.getFilesToMaintenanceOrder();
      this.toastHandlerService.showToast(
        'success',
        'Se adjunto el archivo exitosamente'
      );
    } catch (error) {
      console.error('Error catch:', error);
    }
  }


  updateFormState(maintenanceOrder: MaintenanceOrderModel) {
    this.disabledForm = false;
    switch (maintenanceOrder.maintenanceOrderStateId) {
      case MaintenanceOrderEnums.abierta: {
        if (this.maintenanceOrderClass == ClassMaintenanceOrderEnum.enTaller) {
          this.iconStateMaintenanceOrder = 'pi pi-lock-open';
          this.titleStateMaintenanceOrder = 'Cierre Inicial';
          this.maintenanceOrderStateString = "Abierta";
        } else {
          this.iconStateMaintenanceOrder = 'pi pi-lock-open';
          this.titleStateMaintenanceOrder = 'Cierre Final';
          this.maintenanceOrderStateString = "Abierta";
        }
        this.disabledReverseStateBtn = true;
        this.disabledChangeStateBtn = false;
        this.changeSwChargeConstructionSite(maintenanceOrder.swChargeConstructionSite, true);
        this.changeMaintenanceOrderType(maintenanceOrder.maintenanceOrderTypeId, true);

        const enable = maintenanceOrder.maintenanceOrderTypeId != TypeMaintenanceOrderEnum.mantenimientoProgramado;
        setTimeout(() => this.formControlStateService.setControlState(this.formMaintenanceOrder, [
          'maintenanceOrderTypeId', 'workshopType', 'maintenanceTypeId', 'dateInitialMaintenanceOrder', 'initialDiagnosis'], enable), 100);
        break;
      }
      case MaintenanceOrderEnums.cierreInicial: {
        if (this.maintenanceOrderClass == ClassMaintenanceOrderEnum.enTaller) {
          setTimeout(() => { this.formMaintenanceOrder.controls['alterNumber'].disable() }, 100);
          setTimeout(() => { this.formMaintenanceOrder.controls['dateMaintenanceOrder'].disable() }, 100);
          setTimeout(() => { this.formMaintenanceOrder.controls['maintenanceOrderTypeId'].disable() }, 100);
          setTimeout(() => { this.formMaintenanceOrder.controls['workshopType'].disable() }, 100);
        }
        if (this.maintenanceOrderType == TypeMaintenanceOrderEnum.equipoPropioDeObra) {
          setTimeout(() => this.formMaintenanceOrder.controls['clientId'].disable(), 100);
          setTimeout(() => this.formMaintenanceOrder.controls['costCenterId'].disable(), 100);
        }
        this.iconStateMaintenanceOrder = 'pi pi-unlock';
        this.titleStateMaintenanceOrder = 'Cierre Final';
        this.maintenanceOrderStateString = "Cierre Inicial";
        this.disabledReverseStateBtn = false;
        this.disabledChangeStateBtn = false;
        this.changeSwChargeConstructionSite(maintenanceOrder.swChargeConstructionSite, true);
        break;
      }
      case MaintenanceOrderEnums.cierreFinal: {
        this.iconStateMaintenanceOrder = 'pi pi-lock';
        this.titleStateMaintenanceOrder = 'Cierre Final';
        this.maintenanceOrderStateString = "Cierre Final";
        this.disabledReverseStateBtn = false;
        this.disabledChangeStateBtn = true;
        this.disabledForm = true;
        this.formMaintenanceOrder.disable();
        break;
      }
      case MaintenanceOrderEnums.anulada: {
        this.iconStateMaintenanceOrder = 'pi pi-lock';
        this.titleStateMaintenanceOrder = 'Abrir';
        this.maintenanceOrderStateString = "Anulada";
        this.disabledReverseStateBtn = true;
        this.disabledChangeStateBtn = true;
        this.disabledForm = true;
        this.formMaintenanceOrder.disable();
        break;
      }
      default: {
        this.iconStateMaintenanceOrder = 'pi pi-lock-open';
        this.titleStateMaintenanceOrder = 'Cerrar';
        this.maintenanceOrderStateString = "Abierta";
        break;
      }
    }

    if (maintenanceOrder.swBlock) {
      this.formMaintenanceOrder.disable();
      this.disabledForm = true;
      this.disabledReverseStateBtn = true;
      this.disabledChangeStateBtn = true;
    }

    setTimeout(() => this.formMaintenanceOrder.controls['branchId'].enable(), 100);
    setTimeout(() => this.formMaintenanceOrder.controls['maintenanceOrderClassId'].enable(), 100);
    setTimeout(() => this.formMaintenanceOrder.controls['consecutive'].enable(), 100);
    setTimeout(() => this.formMaintenanceOrder.controls['swBlock'].enable(), 100);
    if (maintenanceOrder.maintenanceOrderId == 0 || maintenanceOrder.maintenanceOrderId == null) {
      if (this.maintenanceOrderId == 0) setTimeout(() => this.formMaintenanceOrder.controls['consecutive'].disable(), 100);
    }

    if (this.maintenanceOrderContract.swCostRepairState) {
      this.iconStateVrRepairCost = "pi pi-lock";
      this.titleStateVrRepairCost = "Abrir";
    } else {
      this.iconStateVrRepairCost = "pi pi-lock-open";
      this.titleStateVrRepairCost = "Cerrar";
    }
    setTimeout(() => { this.formMaintenanceOrder.controls['costRepairValue'].disable() }, 100);
    if (maintenanceOrder.maintenanceOrderClassId == ClassMaintenanceOrderEnum.programada && (maintenanceOrder.consecutiveMaintenanceScheduling != null ||
      maintenanceOrder.maintenanceOrderOriginId != null)) {
      setTimeout(() => this.formControlStateService.setControlState(this.formMaintenanceOrder, [
        'clientId', 'costCenterId'], false), 100);
      this.articleDisabled = true;
    } else {
      this.articleDisabled = false;
    }
  }

  updateInputsForAttachFiles() {
    this.inputsForAttachFiles$.next({
      listFiles: this.listFiles,
      labelConsecutive: this.maintenanceOrderContract.consecutive,
      disabled: this.maintenanceOrderContract.maintenanceOrderStateId != MaintenanceOrderEnums.abierta
    });
  }

  validateForm(maintenanceOrder: MaintenanceOrderModel) {
    this.formMaintenanceOrder = this.formBuilder.group({
      branchId: [maintenanceOrder.branchId, [Validators.required, Validators.min(1)]],
      consecutive: [maintenanceOrder.consecutive],
      alterNumber: [maintenanceOrder.alterNumber],
      maintenanceOrderClassId: [maintenanceOrder.maintenanceOrderClassId, [Validators.required, Validators.min(1)]],
      maintenanceOrderTypeId: [maintenanceOrder.maintenanceOrderTypeId, [Validators.required, Validators.min(1)]],
      maintenanceTypeId: [maintenanceOrder.maintenanceTypeId, [Validators.required, Validators.min(1)]],
      costCenterId: [maintenanceOrder.costCenterId],
      clientId: [maintenanceOrder.clientId, [Validators.required, Validators.min(1)]],
      transporterId: [maintenanceOrder.transporterId],
      vehicleId: [maintenanceOrder.vehicleId],
      transportValue: [maintenanceOrder.transportValue, [Validators.min(0), Validators.max(99999999999.99)]],
      transportValueToPay: [maintenanceOrder.transportValueToPay, [Validators.min(0), Validators.max(99999999999.99)]],
      valueToInvoiced: [maintenanceOrder.valueToInvoiced, [Validators.min(0), Validators.max(99999999999.99)]],
      invoiceNumber: [maintenanceOrder.invoiceNumber],
      swChargeConstructionSite: [maintenanceOrder.swChargeConstructionSite],
      dateMaintenanceOrder: [maintenanceOrder.dateMaintenanceOrder ?
        this.dateConverterService.convertUtcToLocalDateFull(maintenanceOrder.dateMaintenanceOrder) : null, [Validators.required]],
      workshopType: [maintenanceOrder.workshopType],
      costRepairValue: [maintenanceOrder.costRepairValue, [Validators.min(0), Validators.max(99999999999.99)]],
      mechanicId: [maintenanceOrder.mechanicId, [Validators.required, Validators.min(1)]],
      dateInitialMaintenanceOrder: [maintenanceOrder.dateInitialMaintenanceOrder ?
        this.dateConverterService.convertUtcToLocalDateFull(maintenanceOrder.dateInitialMaintenanceOrder) : null],
      dateFinalMaintenanceOrder: [maintenanceOrder.dateFinalMaintenanceOrder ?
        this.dateConverterService.convertUtcToLocalDateFull(maintenanceOrder.dateFinalMaintenanceOrder) : null],
      repairHour: [maintenanceOrder.repairHour],
      kmHoromValue: [maintenanceOrder.kmHoromValue],
      initialDiagnosis: [maintenanceOrder.initialDiagnosis, [Validators.maxLength(500)]],
      finalDiagnosis: [maintenanceOrder.finalDiagnosis, [Validators.maxLength(500)]],
      swBlock: [maintenanceOrder.swBlock],
      reportedBy: [maintenanceOrder.reportedBy, [Validators.maxLength(50)]],
      contactConstructionSite: [maintenanceOrder.contactConstructionSite, [Validators.maxLength(50)]],
      receivedBy: [maintenanceOrder.receivedBy, [Validators.maxLength(50)]],
      qualificationId: [maintenanceOrder.qualificationId],
      swDeliveredOnTime: [maintenanceOrder.swDeliveredOnTime],
      dateCompromise: [maintenanceOrder.dateCompromise ?
        this.dateConverterService.convertUtcToLocalDate(maintenanceOrder.dateCompromise) : null],
      maintenancePlan: [maintenanceOrder.maintenancePlan],
      interval: [{ value: maintenanceOrder.interval, disabled: true }],
      consecutiveMaintenanceScheduling: [{ value: maintenanceOrder.consecutiveMaintenanceScheduling, disabled: true }],
      dateMaintenanceScheduling: [{
        value: maintenanceOrder.dateMaintenanceScheduling ?
          this.dateConverterService.convertUtcToLocalDate(maintenanceOrder.dateMaintenanceScheduling) : null, disabled: true
      }],
      maintenanceOrderOriginConsecutive: [{ value: maintenanceOrder.maintenanceOrderOriginConsecutive, disabled: true }],
      devolutionDetailId: [maintenanceOrder.devolutionDetailId]
    });

    if (maintenanceOrder.maintenanceOrderId != 0 && maintenanceOrder.maintenanceOrderId != null) {
      this.maintenanceOrderClass = maintenanceOrder.maintenanceOrderClassId;
      this.maintenanceOrderType = maintenanceOrder.maintenanceOrderTypeId;
      this.maintenanceOrderStateId = maintenanceOrder.maintenanceOrderStateId;
      this.articleId = maintenanceOrder.articleId;
      this.costCenterId = maintenanceOrder.costCenterId != null ? maintenanceOrder.costCenterId : 0;
      this.storeId = maintenanceOrder.storeId;
      this.inputsForModals$.next(
        {
          maintenanceOrderId: maintenanceOrder.maintenanceOrderId,
          maintenanceOrderClassId: maintenanceOrder.maintenanceOrderClassId,
          permissionUpdatable: this.permissionUpdatable,
          maintenanceOrderStateId: maintenanceOrder.maintenanceOrderStateId,
          swCostRepairState: maintenanceOrder.swCostRepairState,
          swBlock: maintenanceOrder.swBlock
        }
      );
      this.getArticle(maintenanceOrder.articleId);
      if (maintenanceOrder.maintenanceOrderClassId == ClassMaintenanceOrderEnum.programada) {
        this.getMaintenancePlansByArticleAsync(this.articleId);
        this.getEquipmentLogbookByArticleIdAsync(this.articleId);
        this.getUnitHours();
        this.getTotalMaintenanceOrderActivities();
      }
      this.getStore(maintenanceOrder.storeId);
      this.getCurrentNoteStage();
      this.updateInputsForSelectEquipmentModal();
    }
    this.getAssociatedDevolutionAsync(maintenanceOrder);
    this.getAssociatedSuspensionAsync(maintenanceOrder);
    this.listTypeMaintenanceOrderForClass = this.listTypeMaintenanceOrder.filter(item => item.class === this.maintenanceOrderClass);
    this.updateFormState(maintenanceOrder);
  }

  async validationsOrderScheduled(): Promise<boolean> {
    if (this.maintenanceOrderContract.maintenanceOrderClassId == ClassMaintenanceOrderEnum.programada) {
      //validar horometro, odómetro solo si la unidad es HORA
      if (this.equipmentLogbookUnitId == this.unitHoursId) {
        const kmHoromValue = this.formMaintenanceOrder.get('kmHoromValue')?.value;
        if (kmHoromValue == null || kmHoromValue <= 0) {
          this.toastHandlerService.showToast(
            'warning',
            'Debe ingresar el Horómetro/Odómetro correctamente.'
          );
          return false;
        }

        if (!await this.validateKmHoromValue(kmHoromValue)) {
          return false;
        }
      }

      //validar si tiene orden reprogramada
      const haveOrigin = await this.validateMaintenanceOrderOrigin()

      if (!haveOrigin) {
        await this.getTotalActivitiesRescheduledAsync();

        //valido si hay actividades sin ejecutar
        if (this.totalActivitiesRescheduled > 0) {
          //Si no tiene orden de origen pregunto si quiere reprogramar
          if (this.maintenanceOrderContract.maintenanceOrderOriginId == null) {
            if (await this.confirmDialogService.confirm(
              'Se encontraron actividades reprogramadas. ¿desea generar la orden de mantenimiento reprogramada?'
            )) {
              this.generateOrderRescheduled = true;
            } else {
              this.generateOrderRescheduled = false;
              return false;
            }
          } else {
            this.toastHandlerService.showToast(
              'warning',
              'No es posible cerrar, se encontraron actividades reprogramadas.'
            );
            return false;
          }
        }
      } else {
        this.generateOrderRescheduled = false;
      }
    }
    return true;
  }


  async validatePermissionUpdatable(): Promise<boolean> {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para modificar ordenes de mantenimiento. Comuníquese con el administrador del sistema.'
      );
      return false;
    }
    return true;
  }


  async validateKmHoromValue(currentKmHoromValue: number): Promise<boolean> {
    try {
      const result = await firstValueFrom(this.maintenanceOrderService.validateKmHoromValue(this.maintenanceOrderContract.maintenanceOrderId, currentKmHoromValue));
      return result;
    } catch (error) {
      console.error('Error al validar el kmHoromValue', error);
      return false;
    }
  }

  async validateMaintenanceOrderOrigin(): Promise<boolean> {
    try {
      const result = await firstValueFrom(this.maintenanceOrderService.validateMaintenanceOrderOrigin(this.maintenanceOrderContract.maintenanceOrderId));
      return result;
    } catch (error) {
      console.error('Error al validar el kmHoromValue', error);
      return false;
    }
  }

  async getTotalActivitiesRescheduledAsync() {
    try {
      this.totalActivitiesRescheduled = await firstValueFrom(this.maintenanceOrderService.getTotalActivitiesRescheduledAsync(this.maintenanceOrderContract.maintenanceOrderId));
    } catch (error) {
      console.error('Error al obtener el total de actividades reprogramadas', error);
    }
  }
}
